/* ============================================================================
   ⚠️ WARNING: AUTO-GENERATED FILE ⚠️
   This file was generated by `npm run generate:theme:tokens`
   DO NOT EDIT DIRECTLY — any changes will be overwritten on the next build.
   DO NOT MODIFY THIS FILE.
============================================================================ */

export const XFARM_PRESET = {
  primitive: {
    emerald: {
      '50': '{tw.emerald.50}',
      '100': '{tw.emerald.100}',
      '200': '{tw.emerald.200}',
      '300': '{tw.emerald.300}',
      '400': '{tw.emerald.400}',
      '500': '{tw.emerald.500}',
      '600': '{tw.emerald.600}',
      '700': '{tw.emerald.700}',
      '800': '{tw.emerald.800}',
      '900': '{tw.emerald.900}',
      '950': '{tw.emerald.950}',
    },
    green: {
      '50': '{tw.green.50}',
      '100': '{tw.green.100}',
      '200': '{tw.green.200}',
      '300': '{tw.green.300}',
      '400': '{tw.green.400}',
      '500': '{tw.green.500}',
      '600': '{tw.green.600}',
      '700': '{tw.green.700}',
      '800': '{tw.green.800}',
      '900': '{tw.green.900}',
      '950': '{tw.green.950}',
    },
    lime: {
      '50': '{tw.lime.50}',
      '100': '{tw.lime.100}',
      '200': '{tw.lime.200}',
      '300': '{tw.lime.300}',
      '400': '{tw.lime.400}',
      '500': '{tw.lime.500}',
      '600': '{tw.lime.600}',
      '700': '{tw.lime.700}',
      '800': '{tw.lime.800}',
      '900': '{tw.lime.900}',
      '950': '{tw.lime.950}',
    },
    red: {
      '50': '{tw.red.50}',
      '100': '{tw.red.100}',
      '200': '{tw.red.200}',
      '300': '{tw.red.300}',
      '400': '{tw.red.400}',
      '500': '{tw.red.500}',
      '600': '{tw.red.600}',
      '700': '{tw.red.700}',
      '800': '{tw.red.800}',
      '900': '{tw.red.900}',
      '950': '{tw.red.950}',
    },
    orange: {
      '50': '{tw.orange.50}',
      '100': '{tw.orange.100}',
      '200': '{tw.orange.200}',
      '300': '{tw.orange.300}',
      '400': '{tw.orange.400}',
      '500': '{tw.orange.500}',
      '600': '{tw.orange.600}',
      '700': '{tw.orange.700}',
      '800': '{tw.orange.800}',
      '900': '{tw.orange.900}',
      '950': '{tw.orange.950}',
    },
    amber: {
      '50': '{tw.amber.50}',
      '100': '{tw.amber.100}',
      '200': '{tw.amber.200}',
      '300': '{tw.amber.300}',
      '400': '{tw.amber.400}',
      '500': '{tw.amber.500}',
      '600': '{tw.amber.600}',
      '700': '{tw.amber.700}',
      '800': '{tw.amber.800}',
      '900': '{tw.amber.900}',
      '950': '{tw.amber.950}',
    },
    yellow: {
      '50': '{tw.yellow.50}',
      '100': '{tw.yellow.100}',
      '200': '{tw.yellow.200}',
      '300': '{tw.yellow.300}',
      '400': '{tw.yellow.400}',
      '500': '{tw.yellow.500}',
      '600': '{tw.yellow.600}',
      '700': '{tw.yellow.700}',
      '800': '{tw.yellow.800}',
      '900': '{tw.yellow.900}',
      '950': '{tw.yellow.950}',
    },
    teal: {
      '50': '{tw.teal.50}',
      '100': '{tw.teal.100}',
      '200': '{tw.teal.200}',
      '300': '{tw.teal.300}',
      '400': '{tw.teal.400}',
      '500': '{tw.teal.500}',
      '600': '{tw.teal.600}',
      '700': '{tw.teal.700}',
      '800': '{tw.teal.800}',
      '900': '{tw.teal.900}',
      '950': '{tw.teal.950}',
    },
    cyan: {
      '50': '{tw.cyan.50}',
      '100': '{tw.cyan.100}',
      '200': '{tw.cyan.200}',
      '300': '{tw.cyan.300}',
      '400': '{tw.cyan.400}',
      '500': '{tw.cyan.500}',
      '600': '{tw.cyan.600}',
      '700': '{tw.cyan.700}',
      '800': '{tw.cyan.800}',
      '900': '{tw.cyan.900}',
      '950': '{tw.cyan.950}',
    },
    sky: {
      '50': '{tw.sky.50}',
      '100': '{tw.sky.100}',
      '200': '{tw.sky.200}',
      '300': '{tw.sky.300}',
      '400': '{tw.sky.400}',
      '500': '{tw.sky.500}',
      '600': '{tw.sky.600}',
      '700': '{tw.sky.700}',
      '800': '{tw.sky.800}',
      '900': '{tw.sky.900}',
      '950': '{tw.sky.950}',
    },
    blue: {
      '50': '{tw.blue.50}',
      '100': '{tw.blue.100}',
      '200': '{tw.blue.200}',
      '300': '{tw.blue.300}',
      '400': '{tw.blue.400}',
      '500': '{tw.blue.500}',
      '600': '{tw.blue.600}',
      '700': '{tw.blue.700}',
      '800': '{tw.blue.800}',
      '900': '{tw.blue.900}',
      '950': '{tw.blue.950}',
    },
    indigo: {
      '50': '{tw.indigo.50}',
      '100': '{tw.indigo.100}',
      '200': '{tw.indigo.200}',
      '300': '{tw.indigo.300}',
      '400': '{tw.indigo.400}',
      '500': '{tw.indigo.500}',
      '600': '{tw.indigo.600}',
      '700': '{tw.indigo.700}',
      '800': '{tw.indigo.800}',
      '900': '{tw.indigo.900}',
      '950': '{tw.indigo.950}',
    },
    violet: {
      '50': '{tw.violet.50}',
      '100': '{tw.violet.100}',
      '200': '{tw.violet.200}',
      '300': '{tw.violet.300}',
      '400': '{tw.violet.400}',
      '500': '{tw.violet.500}',
      '600': '{tw.violet.600}',
      '700': '{tw.violet.700}',
      '800': '{tw.violet.800}',
      '900': '{tw.violet.900}',
      '950': '{tw.violet.950}',
    },
    purple: {
      '50': '{tw.purple.50}',
      '100': '{tw.purple.100}',
      '200': '{tw.purple.200}',
      '300': '{tw.purple.300}',
      '400': '{tw.purple.400}',
      '500': '{tw.purple.500}',
      '600': '{tw.purple.600}',
      '700': '{tw.purple.700}',
      '800': '{tw.purple.800}',
      '900': '{tw.purple.900}',
      '950': '{tw.purple.950}',
    },
    fuchsia: {
      '50': '{tw.fuchsia.50}',
      '100': '{tw.fuchsia.100}',
      '200': '{tw.fuchsia.200}',
      '300': '{tw.fuchsia.300}',
      '400': '{tw.fuchsia.400}',
      '500': '{tw.fuchsia.500}',
      '600': '{tw.fuchsia.600}',
      '700': '{tw.fuchsia.700}',
      '800': '{tw.fuchsia.800}',
      '900': '{tw.fuchsia.900}',
      '950': '{tw.fuchsia.950}',
    },
    pink: {
      '50': '{tw.pink.50}',
      '100': '{tw.pink.100}',
      '200': '{tw.pink.200}',
      '300': '{tw.pink.300}',
      '400': '{tw.pink.400}',
      '500': '{tw.pink.500}',
      '600': '{tw.pink.600}',
      '700': '{tw.pink.700}',
      '800': '{tw.pink.800}',
      '900': '{tw.pink.900}',
      '950': '{tw.pink.950}',
    },
    rose: {
      '50': '{tw.rose.50}',
      '100': '{tw.rose.100}',
      '200': '{tw.rose.200}',
      '300': '{tw.rose.300}',
      '400': '{tw.rose.400}',
      '500': '{tw.rose.500}',
      '600': '{tw.rose.600}',
      '700': '{tw.rose.700}',
      '800': '{tw.rose.800}',
      '900': '{tw.rose.900}',
      '950': '{tw.rose.950}',
    },
    slate: {
      '50': '{tw.slate.50}',
      '100': '{tw.slate.100}',
      '200': '{tw.slate.200}',
      '300': '{tw.slate.300}',
      '400': '{tw.slate.400}',
      '500': '{tw.slate.500}',
      '600': '{tw.slate.600}',
      '700': '{tw.slate.700}',
      '800': '{tw.slate.800}',
      '900': '{tw.slate.900}',
      '950': '{tw.slate.950}',
    },
    gray: {
      '50': '{tw.slate.50}',
      '100': '{tw.slate.100}',
      '200': '{tw.slate.200}',
      '300': '{tw.slate.300}',
      '400': '{tw.slate.400}',
      '500': '{tw.slate.500}',
      '600': '{tw.slate.600}',
      '700': '{tw.slate.700}',
      '800': '{tw.slate.800}',
      '900': '{tw.slate.900}',
      '950': '{tw.slate.950}',
    },
    zinc: {
      '50': '{tw.zinc.50}',
      '100': '{tw.zinc.100}',
      '200': '{tw.zinc.200}',
      '300': '{tw.zinc.300}',
      '400': '{tw.zinc.400}',
      '500': '{tw.zinc.500}',
      '600': '{tw.zinc.600}',
      '700': '{tw.zinc.700}',
      '800': '{tw.zinc.800}',
      '900': '{tw.zinc.900}',
      '950': '{tw.zinc.950}',
    },
    neutral: {
      '50': '{tw.neutral.50}',
      '100': '{tw.neutral.100}',
      '200': '{tw.neutral.200}',
      '300': '{tw.neutral.300}',
      '400': '{tw.neutral.400}',
      '500': '{tw.neutral.500}',
      '600': '{tw.neutral.600}',
      '700': '{tw.neutral.700}',
      '800': '{tw.neutral.800}',
      '900': '{tw.neutral.900}',
      '950': '{tw.neutral.950}',
    },
    stone: {
      '50': '{tw.stone.50}',
      '100': '{tw.stone.100}',
      '200': '{tw.stone.200}',
      '300': '{tw.stone.300}',
      '400': '{tw.stone.400}',
      '500': '{tw.stone.500}',
      '600': '{tw.stone.600}',
      '700': '{tw.stone.700}',
      '800': '{tw.stone.800}',
      '900': '{tw.stone.900}',
      '950': '{tw.stone.950}',
    },
    coral: {
      '50': '{tw.coral.50}',
      '100': '{tw.coral.100}',
      '200': '{tw.coral.200}',
      '300': '{tw.coral.300}',
      '400': '{tw.coral.400}',
      '500': '{tw.coral.500}',
      '600': '{tw.coral.600}',
      '700': '{tw.coral.700}',
      '800': '{tw.coral.800}',
      '900': '{tw.coral.900}',
      '950': '{tw.coral.950}',
    },
    grass: {
      '50': '{tw.grass.50}',
      '100': '{tw.grass.100}',
      '200': '{tw.grass.200}',
      '300': '{tw.grass.300}',
      '400': '{tw.grass.400}',
      '500': '{tw.grass.500}',
      '600': '{tw.grass.600}',
      '700': '{tw.grass.700}',
      '800': '{tw.grass.800}',
      '900': '{tw.grass.900}',
      '950': '{tw.grass.950}',
    },
    coal: {
      '50': '{tw.coal.50}',
      '100': '{tw.coal.100}',
      '200': '{tw.coal.200}',
      '300': '{tw.coal.300}',
      '400': '{tw.coal.400}',
      '500': '{tw.coal.500}',
      '600': '{tw.coal.600}',
      '700': '{tw.coal.700}',
      '800': '{tw.coal.800}',
      '900': '{tw.coal.900}',
      '950': '{tw.coal.950}',
    },
    cherry: {
      '50': '{tw.cherry.50}',
      '100': '{tw.cherry.100}',
      '200': '{tw.cherry.200}',
      '300': '{tw.cherry.300}',
      '400': '{tw.cherry.400}',
      '500': '{tw.cherry.500}',
      '600': '{tw.cherry.600}',
      '700': '{tw.cherry.700}',
      '800': '{tw.cherry.800}',
      '900': '{tw.cherry.900}',
      '950': '{tw.cherry.950}',
    },
    sea: {
      '50': '{tw.sea.50}',
      '100': '{tw.sea.100}',
      '200': '{tw.sea.200}',
      '300': '{tw.sea.300}',
      '400': '{tw.sea.400}',
      '500': '{tw.sea.500}',
      '600': '{tw.sea.600}',
      '700': '{tw.sea.700}',
      '800': '{tw.sea.800}',
      '900': '{tw.sea.900}',
      '950': '{tw.sea.950}',
    },
    coffee: {
      '50': '{tw.coffee.50}',
      '100': '{tw.coffee.100}',
      '200': '{tw.coffee.200}',
      '300': '{tw.coffee.300}',
      '400': '{tw.coffee.400}',
      '500': '{tw.coffee.500}',
      '600': '{tw.coffee.600}',
      '700': '{tw.coffee.700}',
      '800': '{tw.coffee.800}',
      '900': '{tw.coffee.900}',
      '950': '{tw.coffee.950}',
    },
    wine: {
      '50': '{tw.wine.50}',
      '100': '{tw.wine.100}',
      '200': '{tw.wine.200}',
      '300': '{tw.wine.300}',
      '400': '{tw.wine.400}',
      '500': '{tw.wine.500}',
      '600': '{tw.wine.600}',
      '700': '{tw.wine.700}',
      '800': '{tw.wine.800}',
      '900': '{tw.wine.900}',
      '950': '{tw.wine.950}',
    },
    cacao: {
      '50': '{tw.cacao.50}',
      '100': '{tw.cacao.100}',
      '200': '{tw.cacao.200}',
      '300': '{tw.cacao.300}',
      '400': '{tw.cacao.400}',
      '500': '{tw.cacao.500}',
      '600': '{tw.cacao.600}',
      '700': '{tw.cacao.700}',
      '800': '{tw.cacao.800}',
      '900': '{tw.cacao.900}',
      '950': '{tw.cacao.950}',
    },
    curry: {
      '50': '{tw.curry.50}',
      '100': '{tw.curry.100}',
      '200': '{tw.curry.200}',
      '300': '{tw.curry.300}',
      '400': '{tw.curry.400}',
      '500': '{tw.curry.500}',
      '600': '{tw.curry.600}',
      '700': '{tw.curry.700}',
      '800': '{tw.curry.800}',
      '900': '{tw.curry.900}',
      '950': '{tw.curry.950}',
    },
    plum: {
      '50': '{tw.plum.50}',
      '100': '{tw.plum.100}',
      '200': '{tw.plum.200}',
      '300': '{tw.plum.300}',
      '400': '{tw.plum.400}',
      '500': '{tw.plum.500}',
      '600': '{tw.plum.600}',
      '700': '{tw.plum.700}',
      '800': '{tw.plum.800}',
      '900': '{tw.plum.900}',
      '950': '{tw.plum.950}',
    },
    ocean: {
      '50': '{tw.ocean.50}',
      '100': '{tw.ocean.100}',
      '200': '{tw.ocean.200}',
      '300': '{tw.ocean.300}',
      '400': '{tw.ocean.400}',
      '500': '{tw.ocean.500}',
      '600': '{tw.ocean.600}',
      '700': '{tw.ocean.700}',
      '800': '{tw.ocean.800}',
      '900': '{tw.ocean.900}',
      '950': '{tw.ocean.950}',
    },
    kiwi: {
      '50': '{tw.kiwi.50}',
      '100': '{tw.kiwi.100}',
      '200': '{tw.kiwi.200}',
      '300': '{tw.kiwi.300}',
      '400': '{tw.kiwi.400}',
      '500': '{tw.kiwi.500}',
      '600': '{tw.kiwi.600}',
      '700': '{tw.kiwi.700}',
      '800': '{tw.kiwi.800}',
      '900': '{tw.kiwi.900}',
      '950': '{tw.kiwi.950}',
    },
    cement: {
      '50': '{tw.cement.50}',
      '100': '{tw.cement.100}',
      '200': '{tw.cement.200}',
      '300': '{tw.cement.300}',
      '400': '{tw.cement.400}',
      '500': '{tw.cement.500}',
      '600': '{tw.cement.600}',
      '700': '{tw.cement.700}',
      '800': '{tw.cement.800}',
      '900': '{tw.cement.900}',
      '950': '{tw.cement.950}',
    },
    litchi: {
      '50': '{tw.litchi.50}',
      '100': '{tw.litchi.100}',
      '200': '{tw.litchi.200}',
      '300': '{tw.litchi.300}',
      '400': '{tw.litchi.400}',
      '500': '{tw.litchi.500}',
      '600': '{tw.litchi.600}',
      '700': '{tw.litchi.700}',
      '800': '{tw.litchi.800}',
      '900': '{tw.litchi.900}',
      '950': '{tw.litchi.950}',
    },
    caco: {
      '50': '{tw.caco.50}',
      '100': '{tw.caco.100}',
      '200': '{tw.caco.200}',
      '300': '{tw.caco.300}',
      '400': '{tw.caco.400}',
      '500': '{tw.caco.500}',
      '600': '{tw.caco.600}',
      '700': '{tw.caco.700}',
      '800': '{tw.caco.800}',
      '900': '{tw.caco.900}',
      '950': '{tw.caco.950}',
    },
    xfarm: {
      '50': '{tw.xfarm.50}',
      '100': '{tw.xfarm.100}',
      '200': '{tw.xfarm.200}',
      '300': '{tw.xfarm.300}',
      '400': '{tw.xfarm.400}',
      '500': '{tw.xfarm.500}',
      '600': '{tw.xfarm.600}',
      '700': '{tw.xfarm.700}',
      '800': '{tw.xfarm.800}',
      '900': '{tw.xfarm.900}',
      '950': '{tw.xfarm.950}',
    },
    border: {
      radius: {
        none: '0.143rem',
        xs: '{tw.rounded.xs}',
        sm: '{tw.rounded.sm}',
        md: '{tw.rounded.md}',
        lg: '{tw.rounded.lg}',
        xl: '{tw.rounded.xl}',
      },
    },
  },
  semantic: {
    primary: {
      '50': '{xfarm.50}',
      '100': '{xfarm.100}',
      '200': '{xfarm.200}',
      '300': '{xfarm.300}',
      '400': '{xfarm.400}',
      '500': '{xfarm.500}',
      '600': '{xfarm.600}',
      '700': '{xfarm.700}',
      '800': '{xfarm.800}',
      '900': '{xfarm.900}',
      '950': '{xfarm.950}',
    },
    focus: {
      ring: {
        color: '{primary.color}',
        width: '0.071rem',
        offset: '0.143rem',
      },
    },
    form: {
      field: {
        focus: {
          ring: {
            color: '#00000000',
            width: '0rem',
            offset: '0rem',
          },
        },
        padding: {
          x: '{tw.p.3}',
          y: '{tw.p.2}',
        },
        border: {
          radius: '{tw.rounded.md}',
        },
        sm: {
          font: {
            size: '{tw.text-base}',
          },
          padding: {
            x: '{tw.p.2}',
            y: '{tw.p.2_5}',
          },
        },
        lg: {
          font: {
            size: '{tw.text-xl}',
          },
          padding: {
            x: '{tw.p.3_5}',
            y: '{tw.p.3_5}',
          },
        },
      },
    },
    anchor: {
      gutter: '0.143rem',
    },
    icon: {
      size: '1.143rem',
    },
    disabled: {
      opacity: 0.6,
    },
    content: {
      border: {
        radius: '{tw.rounded.md}',
      },
    },
    list: {
      gap: '{tw.gap._x-1}',
      option: {
        border: {
          radius: '{tw.rounded.sm}',
        },
        group: {
          font: {
            weight: '{tw.font-semibold}',
          },
        },
      },
    },
    navigation: {
      list: {
        gap: '{tw.gap._x-1}',
      },
      item: {
        border: {
          radius: '{tw.rounded.sm}',
        },
        gap: '{tw.gap._x-2}',
      },
      submenu: {
        label: {
          font: {
            weight: '{tw.font-semibold}',
          },
        },
        icon: {
          size: '1rem',
        },
      },
    },
    overlay: {
      select: {
        border: {
          radius: '{tw.rounded.md}',
        },
      },
      popover: {
        border: {
          radius: '{tw.rounded.md}',
        },
        padding: '{tw.p.4}',
      },
      modal: {
        border: {
          radius: '{tw.rounded.xl}',
        },
        padding: '{tw.p.5}',
      },
    },
    colorScheme: {
      light: {
        surface: {
          '0': '#ffffff',
          '50': '{tw.slate.50}',
          '100': '{tw.slate.100}',
          '200': '{tw.slate.200}',
          '300': '{tw.slate.300}',
          '400': '{tw.slate.400}',
          '500': '{tw.slate.500}',
          '600': '{tw.slate.600}',
          '700': '{tw.slate.700}',
          '800': '{tw.slate.800}',
          '900': '{tw.slate.900}',
          '950': '{tw.slate.950}',
        },
        primary: {
          color: '{primary.400}',
          contrast: {
            color: '{surface.0}',
          },
          hover: {
            color: '{primary.600}',
          },
          active: {
            color: '{primary.700}',
          },
        },
        highlight: {
          background: '{primary.50}',
          focus: {
            background: '{primary.100}',
            color: '{primary.800}',
          },
          color: '{primary.700}',
        },
        mask: {
          background: '#00000066',
          color: '{surface.200}',
        },
        form: {
          field: {
            background: '{surface.0}',
            disabled: {
              background: '{surface.200}',
              color: '{surface.500}',
            },
            filled: {
              background: '{surface.50}',
              focus: {
                background: '{surface.50}',
              },
              hover: {
                background: '{surface.50}',
              },
            },
            border: {
              color: '{surface.300}',
            },
            hover: {
              border: {
                color: '{surface.400}',
              },
            },
            focus: {
              border: {
                color: '{primary.color}',
              },
            },
            invalid: {
              border: {
                color: '{tw.red.400}',
              },
              placeholder: {
                color: '{tw.red.600}',
              },
            },
            placeholder: {
              color: '{surface.500}',
            },
            float: {
              label: {
                color: '{surface.500}',
                focus: {
                  color: '{surface.500}',
                },
                invalid: {
                  color: '{form.field.invalid.placeholder.color}',
                },
                active: {
                  color: '{surface.500}',
                },
              },
            },
            icon: {
              color: '{surface.400}',
            },
            color: '{surface.700}',
          },
        },
        content: {
          background: '{surface.0}',
          hover: {
            background: '{surface.100}',
            color: '{text.hover.color}',
          },
          border: {
            color: '{surface.200}',
          },
          color: '{text.color}',
        },
        text: {
          color: '{surface.700}',
          hover: {
            color: '{surface.800}',
            muted: {
              color: '{surface.600}',
            },
          },
          muted: {
            color: '{surface.500}',
          },
        },
        overlay: {
          select: {
            background: '{surface.0}',
            border: {
              color: '{surface.200}',
            },
            color: '{text.color}',
          },
          popover: {
            background: '{surface.0}',
            border: {
              color: '{surface.200}',
            },
            color: '{text.color}',
          },
          modal: {
            background: '{surface.0}',
            border: {
              color: '{surface.200}',
            },
            color: '{text.color}',
          },
        },
        list: {
          option: {
            focus: {
              background: '{surface.100}',
              color: '{text.hover.color}',
            },
            selected: {
              background: '{highlight.background}',
              focus: {
                background: '{highlight.focus.background}',
                color: '{highlight.focus.color}',
              },
              color: '{highlight.color}',
            },
            color: '{text.color}',
            icon: {
              color: '{surface.400}',
              focus: {
                color: '{surface.500}',
              },
            },
            group: {
              background: '#00000000',
              color: '{text.muted.color}',
            },
          },
        },
        navigation: {
          item: {
            focus: {
              background: '{surface.100}',
              color: '{text.hover.color}',
            },
            active: {
              background: '{surface.100}',
              color: '{text.hover.color}',
            },
            color: '{text.color}',
            icon: {
              color: '{surface.400}',
              focus: {
                color: '{surface.500}',
              },
              active: {
                color: '{surface.500}',
              },
            },
          },
          submenu: {
            label: {
              background: '#00000000',
              color: '{text.muted.color}',
            },
            icon: {
              color: '{surface.400}',
              focus: {
                color: '{surface.500}',
              },
              active: {
                color: '{surface.500}',
              },
            },
          },
        },
      },
      dark: {
        surface: {
          '0': '#ffffff',
          '50': '{tw.zinc.50}',
          '100': '{tw.zinc.100}',
          '200': '{tw.zinc.200}',
          '300': '{tw.zinc.300}',
          '400': '{tw.zinc.400}',
          '500': '{tw.zinc.500}',
          '600': '{tw.zinc.600}',
          '700': '{tw.zinc.700}',
          '800': '{tw.zinc.800}',
          '900': '{tw.zinc.800}',
          '950': '{tw.zinc.950}',
        },
        primary: {
          color: '{primary.400}',
          contrast: {
            color: '{surface.900}',
          },
          hover: {
            color: '{primary.300}',
          },
          active: {
            color: '{primary.200}',
          },
        },
        highlight: {
          background: '#608e6329',
          focus: {
            background: '#608e633d',
            color: '#ffffffde',
          },
          color: '#ffffffde',
        },
        mask: {
          background: '#00000099',
          color: '{surface.200}',
        },
        form: {
          field: {
            background: '{surface.950}',
            disabled: {
              background: '{surface.700}',
              color: '{surface.400}',
            },
            filled: {
              background: '{surface.800}',
              focus: {
                background: '{surface.800}',
              },
              hover: {
                background: '{surface.800}',
              },
            },
            border: {
              color: '{surface.600}',
            },
            hover: {
              border: {
                color: '{surface.500}',
              },
            },
            focus: {
              border: {
                color: '{primary.color}',
              },
            },
            invalid: {
              border: {
                color: '{tw.red.300}',
              },
              placeholder: {
                color: '{tw.red.400}',
              },
            },
            placeholder: {
              color: '{surface.400}',
            },
            float: {
              label: {
                color: '{surface.400}',
                focus: {
                  color: '{surface.400}',
                },
                invalid: {
                  color: '{form.field.invalid.placeholder.color}',
                },
                active: {
                  color: '{surface.400}',
                },
              },
            },
            icon: {
              color: '{surface.400}',
            },
            color: '{surface.0}',
          },
        },
        content: {
          background: '{surface.900}',
          hover: {
            background: '{surface.800}',
            color: '{text.hover.color}',
          },
          border: {
            color: '{surface.700}',
          },
          color: '{text.color}',
        },
        text: {
          color: '{surface.0}',
          hover: {
            color: '{surface.0}',
            muted: {
              color: '{surface.300}',
            },
          },
          muted: {
            color: '{surface.400}',
          },
        },
        overlay: {
          select: {
            background: '{surface.900}',
            border: {
              color: '{surface.700}',
            },
            color: '{text.color}',
          },
          popover: {
            background: '{surface.900}',
            border: {
              color: '{surface.700}',
            },
            color: '{text.color}',
          },
          modal: {
            background: '{surface.900}',
            border: {
              color: '{surface.700}',
            },
            color: '{text.color}',
          },
        },
        list: {
          option: {
            focus: {
              background: '{surface.800}',
              color: '{text.hover.color}',
            },
            selected: {
              background: '{highlight.background}',
              focus: {
                background: '{highlight.focus.background}',
                color: '{highlight.focus.color}',
              },
              color: '{highlight.color}',
            },
            color: '{text.color}',
            icon: {
              color: '{surface.500}',
              focus: {
                color: '{surface.400}',
              },
            },
            group: {
              background: '#00000000',
              color: '{text.muted.color}',
            },
          },
        },
        navigation: {
          item: {
            focus: {
              background: '{surface.800}',
              color: '{text.hover.color}',
            },
            active: {
              background: '{surface.800}',
              color: '{text.hover.color}',
            },
            color: '{text.color}',
            icon: {
              color: '{surface.500}',
              focus: {
                color: '{surface.400}',
              },
              active: {
                color: '{surface.400}',
              },
            },
          },
          submenu: {
            label: {
              background: '#00000000',
              color: '{text.muted.color}',
            },
            icon: {
              color: '{surface.500}',
              focus: {
                color: '{surface.400}',
              },
              active: {
                color: '{surface.400}',
              },
            },
          },
        },
      },
    },
  },
  components: {
    inputtext: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      sm: {
        font: {
          size: '{tw.text-base}',
        },
        padding: {
          x: '{form.field.sm.padding.x}',
          y: '{form.field.sm.padding.y}',
        },
      },
      lg: {
        padding: {
          x: '{form.field.lg.padding.x}',
          y: '{form.field.lg.padding.y}',
        },
        font: {
          size: '{tw.text-xl}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    panel: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{tw.rounded.xl}',
      },
      color: '{content.color}',
      header: {
        background: '#00000000',
        color: '{text.color}',
        border: {
          color: '{content.border.color}',
          radius: '0rem',
          width: '0rem',
        },
        padding: '{tw.p.4_5}',
      },
      title: {
        font: {
          weight: '{tw.font-semibold}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    iconfield: {
      icon: {
        color: '{form.field.icon.color}',
      },
      figma: {
        sm: {
          icon: {
            size: '{inputtext.sm.font.size}',
          },
        },
        lg: {
          icon: {
            size: '{inputtext.lg.font.size}',
          },
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    toggleswitch: {
      border: {
        color: '#00000000',
        radius: '2.143rem',
        width: '{tw.border.1}',
      },
      hover: {
        border: {
          color: '#00000000',
        },
      },
      checked: {
        border: {
          color: '#00000000',
        },
        hover: {
          border: {
            color: '#00000000',
          },
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
      },
      focus: {
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      width: '2.857rem',
      height: '1.714rem',
      gap: '{tw.gap._x-1_5}',
      handle: {
        border: {
          radius: '0.571rem',
        },
        size: '1.143rem',
      },
      colorScheme: {
        light: {
          background: '{surface.300}',
          hover: {
            background: '{surface.400}',
          },
          checked: {
            background: '{primary.color}',
            hover: {
              background: '{primary.hover.color}',
            },
          },
          handle: {
            background: '{surface.0}',
            hover: {
              background: '{surface.0}',
              color: '{text.color}',
            },
            checked: {
              background: '{surface.0}',
              hover: {
                background: '{surface.0}',
                color: '{primary.hover.color}',
              },
              color: '{primary.color}',
            },
            color: '{text.muted.color}',
            disabled: {
              background: '{form.field.disabled.color}',
            },
          },
          disabled: {
            background: '{form.field.disabled.background}',
          },
        },
        dark: {
          background: '{surface.700}',
          hover: {
            background: '{surface.600}',
          },
          checked: {
            background: '{primary.color}',
            hover: {
              background: '{primary.hover.color}',
            },
          },
          handle: {
            background: '{surface.400}',
            hover: {
              background: '{surface.300}',
              color: '{surface.800}',
            },
            checked: {
              background: '{surface.900}',
              hover: {
                background: '{surface.900}',
                color: '{primary.hover.color}',
              },
              color: '{primary.color}',
            },
            color: '{surface.900}',
            disabled: {
              background: '{surface.900}',
            },
          },
          disabled: {
            background: '{surface.600}',
          },
        },
      },
    },
    floatlabel: {
      color: '{form.field.float.label.color}',
      focus: {
        color: '{form.field.float.label.focus.color}',
      },
      invalid: {
        color: '{form.field.float.label.invalid.color}',
      },
      active: {
        color: '{form.field.float.label.active.color}',
        font: {
          size: '{tw.text-sm}',
          weight: '{tw.font-normal}',
        },
      },
      on: {
        active: {
          background: '{form.field.background}',
        },
        border: {
          radius: '{tw.rounded.xs}',
        },
      },
      position: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      font: {
        weight: '{tw.font-semibold}',
      },
      over: {
        active: {
          top: '-1.429rem',
        },
      },
      in: {
        input: {
          padding: {
            top: '{tw.p.10}',
            bottom: '{form.field.padding.y}',
          },
        },
        active: {
          top: '{form.field.padding.y}',
        },
      },
      figma: {
        over: {
          active: {
            top: '1.429rem',
            gap: '0.571rem',
          },
        },
        on: {
          active: {
            gap: '-0.429rem',
          },
        },
        active: {
          line: {
            height: '{floatlabel.active.font.size}',
          },
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    radiobutton: {
      background: '{form.field.background}',
      checked: {
        background: '{primary.color}',
        hover: {
          background: '{primary.hover.color}',
          border: {
            color: '{primary.hover.color}',
          },
        },
        border: {
          color: '{primary.color}',
        },
        focus: {
          border: {
            color: '{primary.color}',
          },
        },
        disabled: {
          border: {
            color: '{form.field.border.color}',
          },
        },
      },
      disabled: {
        background: '{form.field.disabled.background}',
      },
      filled: {
        background: '{form.field.filled.background}',
      },
      border: {
        color: '{form.field.border.color}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.border.color}',
        },
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
      },
      icon: {
        checked: {
          color: '{primary.contrast.color}',
          hover: {
            color: '{primary.contrast.color}',
          },
        },
        disabled: {
          color: '{form.field.disabled.color}',
        },
        size: '0.857rem',
        sm: {
          size: '0.571rem',
        },
        lg: {
          size: '1.143rem',
        },
      },
      width: '1.429rem',
      height: '1.429rem',
      sm: {
        width: '1.143rem',
        height: '1.143rem',
      },
      lg: {
        width: '1.714rem',
        height: '1.714rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    checkbox: {
      background: '{form.field.background}',
      checked: {
        background: '{primary.color}',
        hover: {
          background: '{primary.hover.color}',
          border: {
            color: '{primary.hover.color}',
          },
        },
        border: {
          color: '{primary.color}',
        },
        focus: {
          border: {
            color: '{primary.color}',
          },
        },
        disabled: {
          border: {
            color: '{form.field.border.color}',
          },
        },
      },
      disabled: {
        background: '{form.field.disabled.background}',
      },
      filled: {
        background: '{form.field.filled.background}',
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{tw.rounded.sm}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.border.color}',
        },
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
      },
      icon: {
        color: '{form.field.color}',
        checked: {
          color: '{primary.contrast.color}',
          hover: {
            color: '{primary.contrast.color}',
          },
        },
        disabled: {
          color: '{form.field.disabled.color}',
        },
        size: '1rem',
        sm: {
          size: '0.857rem',
        },
        lg: {
          size: '1.143rem',
        },
      },
      width: '1.429rem',
      height: '1.429rem',
      sm: {
        width: '1.143rem',
        height: '1.143rem',
      },
      lg: {
        width: '1.714rem',
        height: '1.714rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    autocomplete: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      overlay: {
        background: '{overlay.select.background}',
        border: {
          color: '{overlay.select.border.color}',
          radius: '{overlay.select.border.radius}',
        },
        color: '{overlay.select.color}',
      },
      option: {
        focus: {
          background: '{list.option.focus.background}',
          color: '{list.option.focus.color}',
        },
        selected: {
          background: '{list.option.selected.background}',
          focus: {
            background: '{list.option.selected.focus.background}',
            color: '{list.option.selected.focus.color}',
          },
          color: '{list.option.selected.color}',
        },
        color: '{list.option.color}',
        group: {
          background: '{list.option.group.background}',
          color: '{list.option.group.color}',
          font: {
            weight: '{list.option.group.font.weight}',
          },
        },
        border: {
          radius: '{list.option.border.radius}',
        },
      },
      dropdown: {
        border: {
          color: '{form.field.border.color}',
          radius: '{form.field.border.radius}',
        },
        hover: {
          border: {
            color: '{form.field.border.color}',
          },
        },
        active: {
          border: {
            color: '{form.field.border.color}',
          },
        },
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        width: '2.857rem',
        sm: {
          width: '2.286rem',
        },
        lg: {
          width: '3.429rem',
        },
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      list: {
        gap: '{list.gap}',
      },
      chip: {
        border: {
          radius: '{tw.rounded.sm}',
        },
      },
      figma: {
        chip: {
          padding: {
            top: '0.286rem',
            bottom: '0.286rem',
          },
        },
        input: {
          multiple: {
            gap: '0.286rem',
            padding: {
              y: '0.286rem',
            },
            haschip: {
              padding: {
                x: '0.286rem',
              },
            },
          },
          chip: {
            padding: {
              top: '0.286rem',
              bottom: '0.286rem',
            },
          },
        },
        multiple: {
          border: {
            radius: '0rem',
          },
        },
      },
      colorScheme: {
        light: {
          dropdown: {
            background: '{surface.100}',
            hover: {
              background: '{surface.200}',
              color: '{surface.700}',
            },
            active: {
              background: '{surface.300}',
              color: '{surface.800}',
            },
            color: '{surface.600}',
          },
          chip: {
            focus: {
              background: '{surface.200}',
              color: '{surface.800}',
            },
          },
        },
        dark: {
          dropdown: {
            background: '{surface.800}',
            hover: {
              background: '{surface.700}',
              color: '{surface.200}',
            },
            active: {
              background: '{surface.600}',
              color: '{surface.100}',
            },
            color: '{surface.300}',
          },
          chip: {
            focus: {
              background: '{surface.700}',
              color: '{surface.0}',
            },
          },
        },
      },
    },
    rating: {
      icon: {
        color: '{text.muted.color}',
        hover: {
          color: '{primary.color}',
        },
        active: {
          color: '{primary.color}',
        },
        size: '1.143rem',
      },
      focus: {
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      gap: '{tw.gap._x-1_5}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    avatar: {
      background: '{content.border.color}',
      group: {
        border: {
          color: '{content.background}',
        },
        offset: '-0.857rem',
      },
      color: '{content.color}',
      width: '2.286rem',
      height: '2.286rem',
      font: {
        size: '{tw.text-lg}',
      },
      border: {
        radius: '{content.border.radius}',
      },
      lg: {
        width: '3.429rem',
        height: '3.429rem',
        font: {
          size: '{tw.text-3xl}',
        },
        icon: {
          size: '1.714rem',
        },
        group: {
          offset: '-1.143rem',
        },
      },
      xl: {
        width: '4.571rem',
        height: '4.571rem',
        font: {
          size: '{tw.text-4xl}',
        },
        icon: {
          size: '2.286rem',
        },
        group: {
          offset: '-1.714rem',
        },
      },
      figma: {
        circle: {
          border: {
            radius: '{tw.rounded.2xl}',
          },
          lg: {
            border: {
              radius: '{tw.rounded.3xl}',
            },
          },
          xl: {
            border: {
              radius: '2.286rem',
            },
          },
        },
      },
      icon: {
        size: '1.143rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    chip: {
      remove: {
        icon: {
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          size: '1.143rem',
        },
      },
      border: {
        radius: '{tw.rounded.xl}',
      },
      padding: {
        x: '0.75rem',
        y: '0.5rem',
      },
      gap: '{tw.gap._x-2}',
      image: {
        width: '2.286rem',
        height: '2.286rem',
      },
      icon: {
        size: '1.143rem',
      },
      figma: {
        image: {
          padding: {
            left: '0.286rem',
            y: '0.286rem',
          },
        },
      },
      colorScheme: {
        light: {
          background: '{surface.100}',
          color: '{surface.800}',
          icon: {
            color: '{surface.800}',
          },
          remove: {
            icon: {
              color: '{surface.800}',
            },
          },
        },
        dark: {
          background: '{surface.800}',
          color: '{surface.0}',
          icon: {
            color: '{surface.0}',
          },
          remove: {
            icon: {
              color: '{surface.0}',
            },
          },
        },
      },
    },
    progressbar: {
      background: '{content.border.color}',
      value: {
        background: '{primary.color}',
      },
      label: {
        color: '{primary.contrast.color}',
        font: {
          size: '{tw.text-sm}',
          weight: '{tw.font-semibold}',
        },
      },
      border: {
        radius: '{content.border.radius}',
      },
      height: '1.429rem',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    card: {
      background: '{content.background}',
      color: '{content.color}',
      subtitle: {
        color: '{text.muted.color}',
      },
      border: {
        radius: '{tw.rounded.xl}',
      },
      body: {
        padding: '{tw.p.5}',
        gap: '{tw.gap._x-2}',
      },
      caption: {
        gap: '{tw.gap._x-2}',
      },
      title: {
        font: {
          size: '{tw.text-2xl}',
          weight: '{tw.font-semibold}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    breadcrumb: {
      background: '{content.background}',
      item: {
        color: '{text.muted.color}',
        hover: {
          color: '{text.color}',
        },
        icon: {
          color: '{navigation.item.icon.color}',
          hover: {
            color: '{navigation.item.icon.focus.color}',
          },
        },
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        border: {
          radius: '{content.border.radius}',
        },
        gap: '{navigation.item.gap}',
      },
      separator: {
        color: '{navigation.item.icon.color}',
      },
      padding: '{tw.p.4}',
      gap: '{tw.gap._x-2}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    drawer: {
      background: '{overlay.modal.background}',
      border: {
        color: '{overlay.modal.border.color}',
        radius: '{overlay.modal.border.radius}',
      },
      color: '{overlay.modal.color}',
      header: {
        padding: '{overlay.modal.padding}',
      },
      title: {
        font: {
          weight: '{tw.font-semibold}',
          size: '{tw.text-3xl}',
        },
      },
      footer: {
        padding: '{overlay.modal.padding}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    cascadeselect: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      dropdown: {
        color: '{form.field.icon.color}',
        width: '2.857rem',
      },
      overlay: {
        background: '{overlay.select.background}',
        border: {
          color: '{overlay.select.border.color}',
          radius: '{overlay.select.border.radius}',
        },
        color: '{overlay.select.color}',
      },
      option: {
        focus: {
          background: '{list.option.focus.background}',
          color: '{list.option.focus.color}',
        },
        selected: {
          background: '{list.option.selected.background}',
          focus: {
            background: '{list.option.selected.focus.background}',
            color: '{list.option.selected.focus.color}',
          },
          color: '{list.option.selected.color}',
        },
        color: '{list.option.color}',
        icon: {
          color: '{list.option.icon.color}',
          focus: {
            color: '{list.option.icon.focus.color}',
          },
          size: '1rem',
        },
        border: {
          radius: '{list.option.border.radius}',
        },
      },
      clear: {
        icon: {
          color: '{form.field.icon.color}',
        },
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      list: {
        gap: '{list.gap}',
        mobile: {
          indent: '1.143rem',
        },
      },
      sm: {
        font: {
          size: '{form.field.sm.font.size}',
        },
        padding: {
          x: '{form.field.sm.padding.x}',
          y: '{form.field.sm.padding.y}',
        },
      },
      lg: {
        font: {
          size: '{form.field.lg.font.size}',
        },
        padding: {
          x: '{form.field.lg.padding.x}',
          y: '{form.field.lg.padding.y}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    datepicker: {
      panel: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          radius: '{content.border.radius}',
        },
        color: '{content.color}',
        padding: '{overlay.popover.padding}',
      },
      header: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
        },
        color: '{content.color}',
      },
      dropdown: {
        border: {
          color: '{form.field.border.color}',
          radius: '{form.field.border.radius}',
        },
        hover: {
          border: {
            color: '{form.field.border.color}',
          },
        },
        active: {
          border: {
            color: '{form.field.border.color}',
          },
        },
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        width: '2.857rem',
        sm: {
          width: '2.286rem',
        },
        lg: {
          width: '3.429rem',
        },
      },
      input: {
        icon: {
          color: '{form.field.icon.color}',
        },
      },
      select: {
        month: {
          hover: {
            background: '{content.hover.background}',
            color: '{content.hover.color}',
          },
          color: '{content.color}',
          border: {
            radius: '{content.border.radius}',
          },
        },
        year: {
          hover: {
            background: '{content.hover.background}',
            color: '{content.hover.color}',
          },
          color: '{content.color}',
          border: {
            radius: '{content.border.radius}',
          },
        },
      },
      group: {
        border: {
          color: '{content.border.color}',
        },
        gap: '{overlay.popover.padding}',
      },
      week: {
        day: {
          color: '{content.color}',
          padding: '{tw.p.1}',
          font: {
            weight: '{tw.font-semibold}',
          },
        },
      },
      date: {
        hover: {
          background: '{content.hover.background}',
          color: '{content.hover.color}',
        },
        selected: {
          background: '{primary.color}',
          color: '{primary.contrast.color}',
        },
        range: {
          selected: {
            background: '{highlight.background}',
            color: '{highlight.color}',
          },
        },
        color: '{content.color}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        width: '2.286rem',
        height: '2.286rem',
        border: {
          radius: '{tw.rounded.2xl}',
        },
        padding: '{tw.p.1}',
      },
      buttonbar: {
        border: {
          color: '{content.border.color}',
        },
      },
      time: {
        picker: {
          border: {
            color: '{content.border.color}',
          },
          gap: '{tw.gap._x-2}',
          button: {
            gap: '{tw.gap._x-1_5}',
          },
        },
      },
      title: {
        gap: '{tw.gap._x-2}',
        font: {
          weight: '{tw.font-semibold}',
        },
      },
      month: {
        border: {
          radius: '{content.border.radius}',
        },
        padding: '{tw.p.1_5}',
      },
      year: {
        border: {
          radius: '{content.border.radius}',
        },
        padding: '{tw.p.1_5}',
      },
      colorScheme: {
        light: {
          dropdown: {
            background: '{surface.100}',
            hover: {
              background: '{surface.200}',
              color: '{surface.700}',
            },
            active: {
              background: '{surface.300}',
              color: '{surface.800}',
            },
            color: '{surface.600}',
          },
          today: {
            background: '{surface.200}',
            color: '{surface.900}',
          },
        },
        dark: {
          dropdown: {
            background: '{surface.800}',
            hover: {
              background: '{surface.700}',
              color: '{surface.200}',
            },
            active: {
              background: '{surface.600}',
              color: '{surface.100}',
            },
            color: '{surface.300}',
          },
          today: {
            background: '{surface.700}',
            color: '{surface.0}',
          },
        },
      },
    },
    colorpicker: {
      preview: {
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        width: '1.714rem',
        height: '1.714rem',
        border: {
          radius: '{form.field.border.radius}',
        },
      },
      panel: {
        border: {
          radius: '{overlay.popover.border.radius}',
        },
      },
      colorScheme: {
        light: {
          panel: {
            background: '{surface.800}',
            border: {
              color: '{surface.900}',
            },
          },
          handle: {
            color: '{surface.0}',
          },
        },
        dark: {
          panel: {
            background: '{surface.900}',
            border: {
              color: '{surface.700}',
            },
          },
          handle: {
            color: '{surface.0}',
          },
        },
      },
    },
    select: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      dropdown: {
        color: '{form.field.icon.color}',
        width: '2.857rem',
      },
      overlay: {
        background: '{overlay.select.background}',
        border: {
          color: '{overlay.select.border.color}',
          radius: '{overlay.select.border.radius}',
        },
        color: '{overlay.select.color}',
      },
      option: {
        focus: {
          background: '{list.option.focus.background}',
          color: '{list.option.focus.color}',
        },
        selected: {
          background: '{list.option.selected.background}',
          focus: {
            background: '{list.option.selected.focus.background}',
            color: '{list.option.selected.focus.color}',
          },
          color: '{list.option.selected.color}',
        },
        color: '{list.option.color}',
        group: {
          background: '{list.option.group.background}',
          color: '{list.option.group.color}',
          font: {
            weight: '{list.option.group.font.weight}',
          },
        },
        border: {
          radius: '{list.option.border.radius}',
        },
      },
      clear: {
        icon: {
          color: '{form.field.icon.color}',
        },
      },
      checkmark: {
        color: '{list.option.color}',
        gutter: {
          start: '-0.429rem',
          end: '0.429rem',
        },
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      list: {
        gap: '{list.gap}',
      },
      sm: {
        font: {
          size: '{form.field.sm.font.size}',
        },
        padding: {
          x: '{form.field.sm.padding.x}',
          y: '{form.field.sm.padding.y}',
        },
      },
      lg: {
        font: {
          size: '{form.field.lg.font.size}',
        },
        padding: {
          x: '{form.field.lg.padding.x}',
          y: '{form.field.lg.padding.y}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    editor: {
      toolbar: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          radius: '{content.border.radius}',
        },
        item: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.color}',
          },
          active: {
            color: '{primary.color}',
          },
        },
      },
      overlay: {
        background: '{overlay.select.background}',
        border: {
          color: '{overlay.select.border.color}',
          radius: '{overlay.select.border.radius}',
        },
        color: '{overlay.select.color}',
        option: {
          focus: {
            background: '{list.option.focus.background}',
            color: '{list.option.focus.color}',
          },
          color: '{list.option.color}',
          border: {
            radius: '{list.option.border.radius}',
          },
        },
      },
      content: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          radius: '{content.border.radius}',
        },
        color: '{content.color}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    inputgroup: {
      addon: {
        background: '{form.field.background}',
        border: {
          color: '{form.field.border.color}',
          radius: '{form.field.border.radius}',
        },
        color: '{form.field.icon.color}',
        padding: '{tw.p.2}',
        min: {
          width: '2.857rem',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    textarea: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      sm: {
        padding: {
          x: '{form.field.sm.padding.x}',
          y: '{form.field.sm.padding.y}',
        },
        font: {
          size: '{form.field.sm.font.size}',
        },
      },
      lg: {
        padding: {
          x: '{form.field.lg.padding.x}',
          y: '{form.field.lg.padding.y}',
        },
        font: {
          size: '{form.field.lg.font.size}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    knob: {
      focus: {
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      value: {
        background: '{primary.color}',
      },
      range: {
        background: '{content.border.color}',
      },
      text: {
        color: '{text.muted.color}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    listbox: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
      },
      color: '{form.field.color}',
      option: {
        focus: {
          background: '{list.option.focus.background}',
          color: '{list.option.focus.color}',
        },
        selected: {
          background: '{list.option.selected.background}',
          focus: {
            background: '{list.option.selected.focus.background}',
            color: '{list.option.selected.focus.color}',
          },
          color: '{list.option.selected.color}',
        },
        color: '{list.option.color}',
        group: {
          background: '{list.option.group.background}',
          color: '{list.option.group.color}',
          font: {
            weight: '{list.option.group.font.weight}',
          },
        },
        border: {
          radius: '{list.option.border.radius}',
        },
      },
      checkmark: {
        color: '{list.option.color}',
        gutter: {
          start: '-0.429rem',
          end: '0.429rem',
        },
      },
      list: {
        gap: '{list.gap}',
      },
      colorScheme: {
        light: {
          option: {
            striped: {
              background: '{surface.50}',
            },
          },
        },
        dark: {
          option: {
            striped: {
              background: '{surface.900}',
            },
          },
        },
      },
    },
    multiselect: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      dropdown: {
        color: '{form.field.icon.color}',
        width: '2.857rem',
      },
      overlay: {
        background: '{overlay.select.background}',
        border: {
          color: '{overlay.select.border.color}',
          radius: '{overlay.select.border.radius}',
        },
        color: '{overlay.select.color}',
      },
      option: {
        focus: {
          background: '{list.option.focus.background}',
          color: '{list.option.focus.color}',
        },
        selected: {
          background: '{list.option.selected.background}',
          focus: {
            background: '{list.option.selected.focus.background}',
            color: '{list.option.selected.focus.color}',
          },
          color: '{list.option.selected.color}',
        },
        color: '{list.option.color}',
        group: {
          background: '{list.option.group.background}',
          color: '{list.option.group.color}',
          font: {
            weight: '{list.option.group.font.weight}',
          },
        },
        border: {
          radius: '{list.option.border.radius}',
        },
        gap: '{tw.gap._x-2}',
      },
      clear: {
        icon: {
          color: '{form.field.icon.color}',
        },
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      list: {
        gap: '{list.gap}',
      },
      chip: {
        border: {
          radius: '{tw.rounded.sm}',
        },
      },
      figma: {
        chip: {
          padding: {
            top: '0.286rem',
            bottom: '0.286rem',
          },
        },
        input: {
          multiple: {
            gap: '0.286rem',
          },
        },
      },
      sm: {
        padding: {
          x: '{form.field.sm.padding.x}',
          y: '{form.field.sm.padding.y}',
        },
        font: {
          size: '{form.field.sm.font.size}',
        },
      },
      lg: {
        padding: {
          x: '{form.field.lg.padding.x}',
          y: '{form.field.lg.padding.y}',
        },
        font: {
          size: '{form.field.lg.font.size}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    password: {
      meter: {
        background: '{content.border.color}',
        border: {
          radius: '{content.border.radius}',
        },
        height: '0.857rem',
      },
      icon: {
        color: '{form.field.icon.color}',
      },
      overlay: {
        background: '{overlay.popover.background}',
        border: {
          color: '{overlay.popover.border.color}',
          radius: '{overlay.popover.border.radius}',
        },
        color: '{overlay.popover.color}',
        padding: '{overlay.popover.padding}',
      },
      content: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {
          strength: {
            medium: {
              background: '{amber.500}',
            },
            strong: {
              background: '{green.500}',
            },
            weak: {
              background: '{red.500}',
            },
          },
        },
        dark: {
          strength: {
            medium: {
              background: '{amber.500}',
            },
            strong: {
              background: '{green.400}',
            },
            week: {
              background: '{red.400}',
            },
          },
        },
      },
    },
    slider: {
      track: {
        background: '{content.border.color}',
        border: {
          radius: '{content.border.radius}',
        },
        size: '0.214rem',
      },
      range: {
        background: '{primary.color}',
      },
      handle: {
        background: '{content.border.color}',
        hover: {
          background: '{content.border.color}',
        },
        content: {
          hover: {
            background: '{content.background}',
          },
          width: '1.143rem',
          height: '1.143rem',
          border: {
            radius: '{tw.rounded.lg}',
          },
        },
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        width: '1.429rem',
        height: '1.429rem',
        border: {
          radius: '0.714rem',
        },
      },
      colorScheme: {
        light: {
          handle: {
            content: {
              background: '{surface.0}',
            },
          },
        },
        dark: {
          handle: {
            content: {
              background: '{surface.950}',
            },
          },
        },
      },
    },
    togglebutton: {
      disabled: {
        background: '{form.field.disabled.background}',
        border: {
          color: '{form.field.disabled.background}',
        },
        color: '{form.field.disabled.color}',
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
      },
      focus: {
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      icon: {
        disabled: {
          color: '{form.field.disabled.color}',
        },
      },
      border: {
        radius: '{content.border.radius}',
      },
      gap: '{tw.gap._x-2}',
      font: {
        weight: '{tw.font-semibold}',
      },
      sm: {
        font: {
          size: '{form.field.sm.font.size}',
        },
        padding: '{tw.p.1}',
      },
      lg: {
        font: {
          size: '{form.field.lg.font.size}',
        },
        padding: '{tw.p.1}',
      },
      content: {
        border: {
          radius: '{content.border.radius}',
        },
      },
      padding: '{tw.p.1}',
      figma: {
        sm: {
          icon: {
            size: '{togglebutton.sm.font.size}',
          },
        },
        lg: {
          icon: {
            size: '{togglebutton.lg.font.size}',
          },
        },
      },
      colorScheme: {
        light: {
          background: '{surface.300}',
          checked: {
            background: '{surface.300}',
            color: '{surface.900}',
            border: {
              color: '{surface.300}',
            },
          },
          hover: {
            background: '{surface.300}',
            color: '{surface.700}',
          },
          border: {
            color: '{surface.300}',
          },
          color: '{surface.500}',
          content: {
            checked: {
              background: '{surface.0}',
            },
          },
          icon: {
            color: '{surface.500}',
            hover: {
              color: '{surface.700}',
            },
            checked: {
              color: '{surface.900}',
            },
          },
        },
        dark: {
          background: '{surface.950}',
          checked: {
            background: '{surface.950}',
            color: '{surface.0}',
            border: {
              color: '{surface.950}',
            },
          },
          hover: {
            background: '{surface.950}',
            color: '{surface.300}',
          },
          border: {
            color: '{surface.950}',
          },
          color: '{surface.400}',
          content: {
            checked: {
              background: '{surface.800}',
            },
          },
          icon: {
            color: '{surface.400}',
            hover: {
              color: '{surface.300}',
            },
            checked: {
              color: '{surface.0}',
            },
          },
        },
      },
    },
    treeselect: {
      background: '{form.field.background}',
      disabled: {
        background: '{form.field.disabled.background}',
        color: '{form.field.disabled.color}',
      },
      filled: {
        background: '{form.field.filled.background}',
        focus: {
          background: '{form.field.filled.focus.background}',
        },
        hover: {
          background: '{form.field.filled.hover.background}',
        },
      },
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      hover: {
        border: {
          color: '{form.field.hover.border.color}',
        },
      },
      focus: {
        border: {
          color: '{form.field.focus.border.color}',
        },
        ring: {
          color: '{form.field.focus.ring.color}',
          width: '{form.field.focus.ring.width}',
          offset: '{form.field.focus.ring.offset}',
        },
      },
      invalid: {
        border: {
          color: '{form.field.invalid.border.color}',
        },
        placeholder: {
          color: '{form.field.invalid.placeholder.color}',
        },
      },
      color: '{form.field.color}',
      placeholder: {
        color: '{form.field.placeholder.color}',
      },
      dropdown: {
        color: '{form.field.icon.color}',
        width: '2.857rem',
      },
      overlay: {
        background: '{overlay.select.background}',
        border: {
          color: '{overlay.select.border.color}',
          radius: '{overlay.select.border.radius}',
        },
        color: '{overlay.select.color}',
      },
      clear: {
        icon: {
          color: '{form.field.icon.color}',
        },
      },
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      chip: {
        border: {
          radius: '{tw.rounded.sm}',
        },
      },
      figma: {
        chip: {
          padding: {
            top: '0.286rem',
            bottom: '0.286rem',
          },
        },
        input: {
          multiple: {
            gap: '0.286rem',
          },
        },
      },
      sm: {
        font: {
          size: '{form.field.sm.font.size}',
        },
        padding: {
          x: '{form.field.sm.padding.x}',
          y: '{form.field.sm.padding.y}',
        },
      },
      lg: {
        font: {
          size: '{form.field.lg.font.size}',
        },
        padding: {
          x: '{form.field.lg.padding.x}',
          y: '{form.field.lg.padding.y}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    dataview: {
      border: {
        color: '#00000000',
        width: '0rem',
        radius: '0rem',
      },
      header: {
        background: '{content.background}',
        color: '{content.color}',
        border: {
          color: '{content.border.color}',
          width: '{tw.border.1}',
          radius: '0rem',
        },
      },
      content: {
        background: '{content.background}',
        color: '{content.color}',
        border: {
          color: '#00000000',
          radius: '0rem',
          width: '0rem',
        },
        padding: '0rem',
      },
      footer: {
        background: '{content.background}',
        color: '{content.color}',
        border: {
          color: '{content.border.color}',
          width: '{tw.border.1}',
          radius: '0rem',
        },
      },
      paginator: {
        top: {
          border: {
            color: '{content.border.color}',
            width: '{tw.border.1}',
          },
        },
        bottom: {
          border: {
            color: '{content.border.color}',
            width: '{tw.border.1}',
          },
        },
      },
      padding: '0rem',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    accordion: {
      panel: {
        border: {
          color: '{content.border.color}',
          width: '{tw.border.1}',
        },
      },
      header: {
        color: '{text.muted.color}',
        hover: {
          color: '{text.color}',
          background: '{content.background}',
        },
        active: {
          color: '{text.color}',
          background: '{content.background}',
          hover: {
            background: '{content.background}',
          },
        },
        border: {
          color: '{content.border.color}',
          radius: '{tw.rounded.xl}',
          width: '0rem',
        },
        background: '{content.background}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        toggle: {
          icon: {
            color: '{text.muted.color}',
            hover: {
              color: '{text.color}',
            },
            active: {
              color: '{text.color}',
              hover: {
                color: '{text.color}',
              },
            },
          },
        },
        padding: '{tw.p.4_5}',
        font: {
          weight: '{tw.font-semibold}',
        },
        first: {
          top: {
            border: {
              radius: '{content.border.radius}',
            },
          },
          border: {
            width: '0rem',
          },
        },
        last: {
          bottom: {
            border: {
              radius: '{content.border.radius}',
            },
          },
          active: {
            bottom: {
              border: {
                radius: '0rem',
              },
            },
          },
        },
      },
      content: {
        border: {
          color: '{content.border.color}',
          width: '0rem',
        },
        background: '{content.background}',
        color: '{text.color}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    divider: {
      border: {
        color: '{content.border.color}',
      },
      content: {
        background: '{content.background}',
        color: '{text.color}',
      },
      horizontal: {
        padding: '0rem',
      },
      vertical: {
        padding: '0rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    fieldset: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      legend: {
        background: '{content.background}',
        hover: {
          background: '{content.hover.background}',
          color: '{content.hover.color}',
        },
        color: '{content.color}',
        border: {
          color: '#00000000',
          radius: '{content.border.radius}',
          width: '{tw.border.1}',
        },
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        gap: '{tw.gap._x-2}',
        font: {
          weight: '{tw.font-semibold}',
        },
      },
      toggle: {
        icon: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.hover.muted.color}',
          },
        },
      },
      content: {
        padding: '0rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    splitter: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
      },
      color: '{content.color}',
      gutter: {
        background: '{content.border.color}',
      },
      handle: {
        background: '#00000000',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        size: '1.714rem',
        border: {
          radius: '{content.border.radius}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    scrollpanel: {
      bar: {
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        size: '0.643rem',
        border: {
          radius: '{tw.rounded.sm}',
        },
      },
      colorScheme: {
        light: {
          bar: {
            background: '{surface.100}',
          },
        },
        dark: {
          bar: {
            background: '{surface.800}',
          },
        },
      },
    },
    tabs: {
      tablist: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          width: '{tw.border.1}',
        },
      },
      tab: {
        border: {
          color: '{content.border.color}',
          width: '{tw.border.1}',
        },
        active: {
          border: {
            color: '{primary.color}',
          },
          color: '{primary.color}',
          background: '#00000000',
        },
        color: '{text.muted.color}',
        hover: {
          color: '{text.color}',
          background: '#00000000',
          border: {
            color: '{content.border.color}',
          },
        },
        background: '#00000000',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '-0.071rem',
          },
        },
        font: {
          weight: '{tw.font-semibold}',
        },
        gap: '{tw.gap._x-2}',
      },
      tabpanel: {
        background: '{content.background}',
        color: '{content.color}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
      },
      nav: {
        button: {
          background: '{content.background}',
          color: '{text.muted.color}',
          hover: {
            color: '{text.color}',
          },
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '-0.071rem',
            },
          },
          width: '2.857rem',
        },
      },
      active: {
        bar: {
          background: '{primary.color}',
          height: '0.071rem',
          bottom: '-0.071rem',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    toolbar: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      gap: '{tw.gap._x-2}',
      padding: '{tw.p.3}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    confirmdialog: {
      icon: {
        color: '{overlay.modal.color}',
        size: '2.286rem',
      },
      content: {
        gap: '{tw.gap._x-4}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    confirmpopup: {
      background: '{overlay.popover.background}',
      border: {
        color: '{overlay.popover.border.color}',
        radius: '{overlay.popover.border.radius}',
      },
      color: '{overlay.popover.color}',
      icon: {
        color: '{overlay.popover.color}',
        size: '1.714rem',
      },
      gutter: '0.714rem',
      arrow: {
        offset: '1.429rem',
      },
      content: {
        padding: '{overlay.popover.padding}',
        gap: '{tw.gap._x-4}',
      },
      footer: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    dialog: {
      background: '{overlay.modal.background}',
      color: '{overlay.modal.color}',
      border: {
        color: '{overlay.modal.border.color}',
        radius: '{overlay.modal.border.radius}',
      },
      header: {
        padding: '{overlay.modal.padding}',
        gap: '{tw.gap._x-2}',
      },
      title: {
        font: {
          size: '{tw.text-2xl}',
          weight: '{tw.font-semibold}',
        },
      },
      footer: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    contextmenu: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      item: {
        focus: {
          background: '{navigation.item.focus.background}',
          color: '{navigation.item.focus.color}',
        },
        active: {
          background: '{navigation.item.active.background}',
          color: '{navigation.item.active.color}',
        },
        color: '{navigation.item.color}',
        icon: {
          color: '{navigation.item.icon.color}',
          focus: {
            color: '{navigation.item.icon.focus.color}',
          },
          active: {
            color: '{navigation.item.icon.active.color}',
          },
        },
        border: {
          radius: '{navigation.item.border.radius}',
        },
        gap: '{navigation.item.gap}',
      },
      submenu: {
        icon: {
          color: '{navigation.submenu.icon.color}',
          focus: {
            color: '{navigation.submenu.icon.focus.color}',
          },
          active: {
            color: '{navigation.submenu.icon.active.color}',
          },
          size: '{navigation.submenu.icon.size}',
        },
        mobile: {
          indent: '1.143rem',
        },
      },
      separator: {
        border: {
          color: '{content.border.color}',
        },
      },
      list: {
        gap: '{navigation.list.gap}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    dock: {
      background: '#ffffff1a',
      border: {
        color: '#ffffff33',
        radius: '{tw.rounded.xl}',
      },
      item: {
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        border: {
          radius: '{content.border.radius}',
        },
        padding: '{tw.p.2}',
        size: '3.429rem',
      },
      padding: '{tw.p.2}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    megamenu: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      item: {
        focus: {
          background: '{navigation.item.focus.background}',
          color: '{navigation.item.focus.color}',
        },
        active: {
          background: '{navigation.item.active.background}',
          color: '{navigation.item.active.color}',
        },
        color: '{navigation.item.color}',
        icon: {
          color: '{navigation.item.icon.color}',
          focus: {
            color: '{navigation.item.icon.focus.color}',
          },
          active: {
            color: '{navigation.item.icon.active.color}',
          },
        },
        border: {
          radius: '{navigation.item.border.radius}',
        },
        gap: '{navigation.item.gap}',
      },
      overlay: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          radius: '{content.border.radius}',
        },
        color: '{content.color}',
        padding: '0rem',
        gap: '{tw.gap._x-2}',
      },
      submenu: {
        label: {
          background: '{navigation.submenu.label.background}',
          color: '{navigation.submenu.label.color}',
          font: {
            weight: '{navigation.submenu.label.font.weight}',
          },
        },
        icon: {
          color: '{navigation.submenu.icon.color}',
          focus: {
            color: '{navigation.submenu.icon.focus.color}',
          },
          active: {
            color: '{navigation.submenu.icon.active.color}',
          },
          size: '{navigation.submenu.icon.size}',
        },
        gap: '{navigation.list.gap}',
      },
      separator: {
        border: {
          color: '{content.border.color}',
        },
      },
      mobile: {
        button: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.hover.muted.color}',
            background: '{content.hover.background}',
          },
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          border: {
            radius: '1rem',
          },
          size: '2rem',
        },
      },
      gap: '{tw.gap._x-2}',
      vertical: {
        orientation: {
          gap: '{navigation.list.gap}',
        },
      },
      base: {
        item: {
          border: {
            radius: '{content.border.radius}',
          },
        },
      },
      horizontal: {
        orientation: {
          gap: '{tw.gap._x-2}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    menu: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      item: {
        focus: {
          background: '{navigation.item.focus.background}',
          color: '{navigation.item.focus.color}',
        },
        color: '{navigation.item.color}',
        icon: {
          color: '{navigation.item.icon.color}',
          focus: {
            color: '{navigation.item.icon.focus.color}',
          },
        },
        border: {
          radius: '{navigation.item.border.radius}',
        },
        gap: '{navigation.item.gap}',
      },
      submenu: {
        label: {
          background: '{navigation.submenu.label.background}',
          color: '{navigation.submenu.label.color}',
          font: {
            weight: '{navigation.submenu.label.font.weight}',
          },
        },
      },
      separator: {
        border: {
          color: '{content.border.color}',
        },
      },
      list: {
        gap: '{navigation.list.gap}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    menubar: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      item: {
        focus: {
          background: '{navigation.item.focus.background}',
          color: '{navigation.item.focus.color}',
        },
        active: {
          background: '{navigation.item.active.background}',
          color: '{navigation.item.active.color}',
        },
        color: '{navigation.item.color}',
        icon: {
          color: '{navigation.item.icon.color}',
          focus: {
            color: '{navigation.item.icon.focus.color}',
          },
          active: {
            color: '{navigation.item.icon.active.color}',
          },
        },
        border: {
          radius: '{navigation.item.border.radius}',
        },
        gap: '{navigation.item.gap}',
      },
      submenu: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          radius: '{content.border.radius}',
        },
        icon: {
          color: '{navigation.submenu.icon.color}',
          focus: {
            color: '{navigation.submenu.icon.focus.color}',
          },
          active: {
            color: '{navigation.submenu.icon.active.color}',
          },
          size: '{navigation.submenu.icon.size}',
        },
        gap: '{navigation.list.gap}',
        mobile: {
          indent: '1.143rem',
        },
      },
      separator: {
        border: {
          color: '{content.border.color}',
        },
      },
      mobile: {
        button: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.hover.muted.color}',
            background: '{content.hover.background}',
          },
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          border: {
            radius: '1rem',
          },
          size: '2rem',
        },
      },
      gap: '{tw.gap._x-2}',
      base: {
        item: {
          border: {
            radius: '{content.border.radius}',
          },
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    panelmenu: {
      panel: {
        background: '{content.background}',
        border: {
          color: '{content.border.color}',
          width: '{tw.border.1}',
          radius: '{content.border.radius}',
        },
        color: '{content.color}',
        first: {
          border: {
            width: '{tw.border.1}',
          },
          top: {
            border: {
              radius: '{content.border.radius}',
            },
          },
        },
        last: {
          border: {
            width: '{tw.border.1}',
          },
          bottom: {
            border: {
              radius: '{content.border.radius}',
            },
          },
        },
      },
      item: {
        focus: {
          background: '{navigation.item.focus.background}',
          color: '{navigation.item.focus.color}',
        },
        color: '{navigation.item.color}',
        icon: {
          color: '{navigation.item.icon.color}',
          focus: {
            color: '{navigation.item.icon.focus.color}',
          },
        },
        gap: '{tw.gap._x-2}',
        border: {
          radius: '{content.border.radius}',
        },
      },
      submenu: {
        icon: {
          color: '{navigation.submenu.icon.color}',
          focus: {
            color: '{navigation.submenu.icon.focus.color}',
          },
        },
        indent: '1.143rem',
      },
      gap: '{tw.gap._x-2}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    tieredmenu: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      item: {
        focus: {
          background: '{navigation.item.focus.background}',
          color: '{navigation.item.focus.color}',
        },
        active: {
          background: '{navigation.item.active.background}',
          color: '{navigation.item.active.color}',
        },
        color: '{navigation.item.color}',
        icon: {
          color: '{navigation.item.icon.color}',
          focus: {
            color: '{navigation.item.icon.focus.color}',
          },
          active: {
            color: '{navigation.item.icon.active.color}',
          },
        },
        border: {
          radius: '{navigation.item.border.radius}',
        },
        gap: '{navigation.item.gap}',
      },
      submenu: {
        icon: {
          color: '{navigation.submenu.icon.color}',
          focus: {
            color: '{navigation.submenu.icon.focus.color}',
          },
          active: {
            color: '{navigation.submenu.icon.active.color}',
          },
          size: '{navigation.submenu.icon.size}',
        },
        mobile: {
          indent: '1.143rem',
        },
      },
      separator: {
        border: {
          color: '{content.border.color}',
        },
      },
      list: {
        gap: '{navigation.list.gap}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    organizationchart: {
      node: {
        background: '{content.background}',
        hover: {
          background: '{content.hover.background}',
          color: '{content.hover.color}',
        },
        selected: {
          background: '{highlight.background}',
          color: '{highlight.color}',
        },
        border: {
          color: '{content.border.color}',
          radius: '{content.border.radius}',
        },
        color: '{content.color}',
        toggle: {
          button: {
            background: '{content.background}',
            hover: {
              background: '{content.hover.background}',
              color: '{text.color}',
            },
            border: {
              color: '{content.border.color}',
              radius: '{tw.rounded.xl}',
            },
            color: '{text.muted.color}',
            focus: {
              ring: {
                color: '{focus.ring.color}',
                width: '{focus.ring.width}',
                offset: '{focus.ring.offset}',
              },
            },
            size: '1.714rem',
          },
        },
      },
      connector: {
        color: '{content.border.color}',
        border: {
          radius: '{content.border.radius}',
        },
        height: '1.714rem',
      },
      gutter: '0.857rem',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    paginator: {
      background: '{content.background}',
      color: '{content.color}',
      nav: {
        button: {
          background: '#00000000',
          hover: {
            background: '{content.hover.background}',
            color: '{text.hover.muted.color}',
          },
          selected: {
            background: '{highlight.background}',
            color: '{highlight.color}',
          },
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          color: '{text.muted.color}',
          width: '2.857rem',
          height: '2.857rem',
          border: {
            radius: '1.429rem',
          },
        },
      },
      current: {
        page: {
          report: {
            color: '{text.muted.color}',
          },
        },
      },
      gap: '{tw.gap._x-1_5}',
      border: {
        radius: '{content.border.radius}',
      },
      jump: {
        to: {
          page: {
            input: {
              max: {
                width: '2.857rem',
              },
            },
          },
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    datatable: {
      header: {
        background: '{content.background}',
        border: {
          color: '{datatable.border.color}',
          width: '{tw.border.1}',
        },
        color: '{content.color}',
        cell: {
          background: '{content.background}',
          hover: {
            background: '{content.hover.background}',
            color: '{content.hover.color}',
          },
          selected: {
            background: '{highlight.background}',
            color: '{highlight.color}',
          },
          border: {
            color: '{datatable.border.color}',
          },
          color: '{content.color}',
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '-0.071rem',
            },
          },
          gap: '{tw.gap._x-2}',
        },
      },
      row: {
        background: '{content.background}',
        hover: {
          background: '{content.hover.background}',
          color: '{content.hover.color}',
        },
        selected: {
          background: '{highlight.background}',
          color: '{highlight.color}',
        },
        color: '{content.color}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '-0.071rem',
          },
        },
        toggle: {
          button: {
            hover: {
              background: '{content.hover.background}',
              color: '{text.color}',
            },
            selected: {
              hover: {
                background: '{content.background}',
                color: '{primary.color}',
              },
            },
            color: '{text.muted.color}',
            focus: {
              ring: {
                color: '{focus.ring.color}',
                width: '{focus.ring.width}',
                offset: '{focus.ring.offset}',
              },
            },
            size: '2rem',
            border: {
              radius: '1rem',
            },
          },
        },
      },
      body: {
        cell: {
          border: {
            color: '{datatable.border.color}',
          },
        },
      },
      footer: {
        cell: {
          background: '{content.background}',
          border: {
            color: '{datatable.border.color}',
          },
          color: '{content.color}',
        },
        background: '{content.background}',
        border: {
          color: '{datatable.border.color}',
          width: '{tw.border.1}',
        },
        color: '{content.color}',
      },
      drop: {
        point: {
          color: '{primary.color}',
        },
      },
      resize: {
        indicator: {
          color: '{primary.color}',
          width: '0.071rem',
        },
      },
      sort: {
        icon: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.hover.muted.color}',
          },
          size: '1rem',
        },
      },
      filter: {
        overlay: {
          select: {
            background: '{overlay.select.background}',
            border: {
              color: '{overlay.select.border.color}',
              radius: '{overlay.select.border.radius}',
            },
            color: '{overlay.select.color}',
          },
          popover: {
            background: '{overlay.popover.background}',
            border: {
              color: '{overlay.popover.border.color}',
              radius: '{overlay.popover.border.radius}',
            },
            color: '{overlay.popover.color}',
            padding: '{overlay.popover.padding}',
            gap: '{tw.gap._x-2}',
          },
        },
        rule: {
          border: {
            color: '{content.border.color}',
          },
        },
        constraint: {
          focus: {
            background: '{list.option.focus.background}',
            color: '{list.option.focus.color}',
          },
          selected: {
            background: '{list.option.selected.background}',
            focus: {
              background: '{list.option.selected.focus.background}',
              color: '{list.option.selected.focus.color}',
            },
            color: '{list.option.selected.color}',
          },
          color: '{list.option.color}',
          separator: {
            border: {
              color: '{content.border.color}',
            },
          },
          list: {
            gap: '{list.gap}',
          },
          border: {
            radius: '{list.option.border.radius}',
          },
        },
        inline: {
          gap: '0.571rem',
        },
      },
      paginator: {
        top: {
          border: {
            color: '{datatable.border.color}',
            width: '{tw.border.1}',
          },
        },
        bottom: {
          border: {
            color: '{datatable.border.color}',
            width: '{tw.border.1}',
          },
        },
      },
      column: {
        title: {
          font: {
            weight: '{tw.font-semibold}',
          },
        },
        footer: {
          font: {
            weight: '{tw.font-semibold}',
          },
        },
        resizer: {
          width: '0.571rem',
        },
      },
      loading: {
        icon: {
          size: '2.286rem',
        },
      },
      colorScheme: {
        light: {
          border: {
            color: '{content.border.color}',
          },
          row: {
            striped: {
              background: '{surface.50}',
            },
          },
          body: {
            cell: {
              selected: {
                border: {
                  color: '{primary.100}',
                },
              },
            },
          },
        },
        dark: {
          border: {
            color: '{content.border.color}',
          },
          row: {
            striped: {
              background: '{surface.950}',
            },
          },
          body: {
            cell: {
              selected: {
                border: {
                  color: '{primary.900}',
                },
              },
            },
          },
        },
      },
    },
    timeline: {
      event: {
        marker: {
          background: '{content.background}',
          border: {
            color: '{content.border.color}',
            radius: '0.643rem',
            width: '{tw.border.2}',
          },
          content: {
            background: '{primary.color}',
            border: {
              radius: '0.214rem',
            },
            size: '0.429rem',
          },
          size: '1.286rem',
        },
        connector: {
          color: '{content.border.color}',
          size: '0.143rem',
        },
        min: {
          height: '5.714rem',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    tree: {
      background: '{content.background}',
      color: '{content.color}',
      node: {
        hover: {
          background: '{content.hover.background}',
          color: '{text.hover.color}',
        },
        selected: {
          background: '{highlight.background}',
          color: '{highlight.color}',
        },
        color: '{text.color}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '-0.071rem',
          },
        },
        icon: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.hover.muted.color}',
          },
          selected: {
            color: '{highlight.color}',
          },
        },
        toggle: {
          button: {
            hover: {
              background: '{content.hover.background}',
              color: '{text.hover.muted.color}',
            },
            selected: {
              hover: {
                background: '{content.background}',
                color: '{primary.color}',
              },
            },
            color: '{text.muted.color}',
            focus: {
              ring: {
                color: '{focus.ring.color}',
                width: '{focus.ring.width}',
                offset: '{focus.ring.offset}',
              },
            },
            border: {
              radius: '1rem',
            },
            size: '2rem',
          },
        },
        border: {
          radius: '{content.border.radius}',
        },
        gap: '{tw.gap._x-1_5}',
      },
      padding: '{tw.gap._x-4}',
      gap: '{tw.gap._x-1}',
      indent: '1.143rem',
      loading: {
        icon: {
          size: '2.286rem',
        },
      },
      filter: {
        margin: '0.571rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    virtualscroller: {
      loader: {
        mask: {
          background: '{content.background}',
          color: '{text.muted.color}',
        },
        icon: {
          size: '2.286rem',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    carousel: {
      indicator: {
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        list: {
          padding: '{tw.p.4}',
          gap: '{tw.gap._x-2}',
        },
        width: '2.286rem',
        height: '0.571rem',
        border: {
          radius: '{content.border.radius}',
        },
      },
      content: {
        gap: '{tw.gap._x-1_5}',
      },
      colorScheme: {
        light: {
          indicator: {
            background: '{surface.200}',
            hover: {
              background: '{surface.300}',
            },
            active: {
              background: '{primary.color}',
            },
          },
          figma: {
            item: {
              tag: {
                background: '#00000000',
              },
            },
          },
        },
        dark: {
          indicator: {
            background: '{surface.700}',
            hover: {
              background: '{surface.600}',
            },
            active: {
              background: '{primary.color}',
            },
          },
          figma: {
            item: {
              tag: {
                background: '#000000b3',
              },
            },
          },
        },
      },
    },
    image: {
      preview: {
        mask: {
          background: '{mask.background}',
          color: '{mask.color}',
        },
        icon: {
          size: '1.714rem',
        },
      },
      toolbar: {
        background: '#ffffff1a',
        border: {
          color: '#ffffff33',
          width: '{tw.border.1}',
          radius: '2.143rem',
        },
        padding: '{tw.p.2}',
        gap: '{tw.gap._x-2}',
        position: {
          right: '1.143rem',
          top: '1.143rem',
        },
        blur: '0.571rem',
      },
      action: {
        hover: {
          background: '#ffffff1a',
          color: '{surface.0}',
        },
        color: '{surface.50}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        size: '3.429rem',
        icon: {
          size: '1.714rem',
        },
        border: {
          radius: '{tw.rounded.3xl}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    treetable: {
      header: {
        background: '{content.background}',
        border: {
          color: '{treetable.border.color}',
          width: '{tw.border.1}',
        },
        color: '{content.color}',
        cell: {
          background: '{content.background}',
          hover: {
            background: '{content.hover.background}',
            color: '{content.hover.color}',
          },
          selected: {
            background: '{highlight.background}',
            color: '{highlight.color}',
          },
          border: {
            color: '{treetable.border.color}',
          },
          color: '{content.color}',
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '-0.071rem',
            },
          },
          gap: '{tw.gap._x-2}',
        },
      },
      row: {
        background: '{content.background}',
        hover: {
          background: '{content.hover.background}',
          color: '{content.hover.color}',
        },
        selected: {
          background: '{highlight.background}',
          color: '{highlight.color}',
        },
        color: '{content.color}',
        focus: {
          ring: {
            color: '{focus.ring.color}',
            width: '{focus.ring.width}',
            offset: '-0.071rem',
          },
        },
      },
      body: {
        cell: {
          border: {
            color: '{treetable.border.color}',
          },
          gap: '{tw.gap._x-2}',
        },
      },
      footer: {
        cell: {
          background: '{content.background}',
          border: {
            color: '{treetable.border.color}',
          },
          color: '{content.color}',
        },
        background: '{content.background}',
        border: {
          color: '{treetable.border.color}',
          width: '{tw.border.1}',
        },
        color: '{content.color}',
      },
      resize: {
        indicator: {
          color: '{primary.color}',
          width: '0.071rem',
        },
      },
      sort: {
        icon: {
          color: '{text.muted.color}',
          hover: {
            color: '{text.hover.muted.color}',
          },
          size: '1rem',
        },
      },
      node: {
        toggle: {
          button: {
            hover: {
              background: '{content.hover.background}',
              color: '{text.color}',
            },
            selected: {
              hover: {
                background: '{content.background}',
                color: '{primary.color}',
              },
            },
            color: '{text.muted.color}',
            focus: {
              ring: {
                color: '{focus.ring.color}',
                width: '{focus.ring.width}',
                offset: '{focus.ring.offset}',
              },
            },
            size: '2rem',
            border: {
              radius: '1rem',
            },
          },
        },
      },
      paginator: {
        top: {
          border: {
            color: '{content.border.color}',
            width: '{tw.border.1}',
          },
        },
        bottom: {
          border: {
            color: '{content.border.color}',
            width: '{tw.border.1}',
          },
        },
      },
      column: {
        title: {
          font: {
            weight: '{tw.font-semibold}',
          },
        },
        footer: {
          font: {
            weight: '{tw.font-semibold}',
          },
        },
        resizer: {
          width: '0.571rem',
        },
      },
      loading: {
        icon: {
          size: '2.286rem',
        },
      },
      figma: {
        body: {
          cell: {
            padding: {
              sm: '0.429rem',
              lg: '1.071rem',
            },
          },
        },
        footer: {
          cell: {
            padding: {
              sm: '0.429rem',
              lg: '1.071rem',
            },
          },
          padding: {
            sm: '0.429rem',
            lg: '1.071rem',
          },
        },
        header: {
          cell: {
            padding: {
              sm: '0.429rem',
              lg: '1.071rem',
            },
          },
          padding: {
            sm: '0.429rem',
            lg: '1.071rem',
          },
        },
      },
      colorScheme: {
        light: {
          border: {
            color: '{content.border.color}',
          },
          body: {
            cell: {
              selected: {
                border: {
                  color: '{primary.100}',
                },
              },
            },
          },
        },
        dark: {
          border: {
            color: '{surface.800}',
          },
          body: {
            cell: {
              selected: {
                border: {
                  color: '{primary.900}',
                },
              },
            },
          },
        },
      },
    },
    galleria: {
      border: {
        color: '{content.border.color}',
        width: '{tw.border.1}',
        radius: '{content.border.radius}',
      },
      nav: {
        button: {
          background: '#ffffff1a',
          hover: {
            background: '#ffffff33',
            color: '{surface.0}',
          },
          color: '{surface.100}',
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          size: '3.429rem',
          gutter: '0.571rem',
          prev: {
            border: {
              radius: '{tw.rounded.3xl}',
            },
          },
          next: {
            border: {
              radius: '{tw.rounded.3xl}',
            },
          },
        },
        icon: {
          size: '1.714rem',
        },
      },
      thumbnails: {
        content: {
          background: '{content.background}',
        },
      },
      thumbnail: {
        nav: {
          button: {
            focus: {
              ring: {
                color: '{focus.ring.color}',
                width: '{focus.ring.width}',
                offset: '{focus.ring.offset}',
              },
            },
            size: '2.286rem',
            border: {
              radius: '{content.border.radius}',
            },
            gutter: '0.571rem',
            icon: {
              size: '1.143rem',
            },
          },
        },
      },
      caption: {
        background: '#00000080',
        color: '{surface.100}',
        padding: '{tw.p.4}',
      },
      indicator: {
        button: {
          active: {
            background: '{primary.color}',
          },
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          width: '1.143rem',
          height: '1.143rem',
          border: {
            radius: '{tw.rounded.lg}',
          },
        },
        list: {
          gap: '{tw.gap._x-2}',
          padding: '{tw.p.4}',
        },
      },
      inset: {
        indicator: {
          list: {
            background: '#00000080',
          },
          button: {
            background: '#ffffff66',
            hover: {
              background: '#ffffff99',
            },
            active: {
              background: '#ffffffe6',
            },
          },
        },
      },
      close: {
        button: {
          background: '#ffffff1a',
          hover: {
            background: '#ffffff33',
            color: '{surface.0}',
          },
          color: '{surface.50}',
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          size: '3.429rem',
          gutter: '0.571rem',
          border: {
            radius: '{tw.rounded.3xl}',
          },
          icon: {
            size: '1.714rem',
          },
        },
      },
      colorScheme: {
        light: {
          thumbnail: {
            nav: {
              button: {
                hover: {
                  background: '{surface.100}',
                  color: '{surface.700}',
                },
                color: '{surface.600}',
              },
            },
          },
          indicator: {
            button: {
              background: '{surface.200}',
              hover: {
                background: '{surface.300}',
              },
            },
          },
        },
        dark: {
          thumbnail: {
            nav: {
              button: {
                hover: {
                  background: '{surface.700}',
                  color: '{surface.0}',
                },
                color: '{surface.400}',
              },
            },
          },
          indicator: {
            button: {
              background: '{surface.700}',
              hover: {
                background: '{surface.600}',
              },
            },
          },
        },
      },
    },
    popover: {
      background: '{overlay.popover.background}',
      border: {
        color: '{overlay.popover.border.color}',
        radius: '{overlay.popover.border.radius}',
      },
      color: '{overlay.popover.color}',
      gutter: '0.714rem',
      arrow: {
        offset: '1.429rem',
      },
      content: {
        padding: '{overlay.popover.padding}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    fileupload: {
      background: '{content.background}',
      border: {
        color: '{content.border.color}',
        radius: '{content.border.radius}',
      },
      color: '{content.color}',
      header: {
        background: '#00000000',
        color: '{text.color}',
        border: {
          color: '#00000000',
          width: '0rem',
          radius: '0rem',
        },
        padding: '{tw.p.4_5}',
        gap: '{tw.gap._x-2}',
      },
      content: {
        highlight: {
          border: {
            color: '{primary.color}',
          },
        },
        gap: '{tw.gap._x-4}',
      },
      file: {
        border: {
          color: '{content.border.color}',
        },
        padding: '{tw.p.4}',
        gap: '{tw.gap._x-4}',
        info: {
          gap: '{tw.gap._x-2}',
        },
        list: {
          gap: '{tw.gap._x-2}',
        },
      },
      progressbar: {
        height: '0.286rem',
      },
      basic: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    stepper: {
      separator: {
        background: '{content.border.color}',
        active: {
          background: '{primary.color}',
        },
        size: '0.143rem',
      },
      step: {
        header: {
          focus: {
            ring: {
              color: '{focus.ring.color}',
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
          padding: '0rem',
          border: {
            radius: '{content.border.radius}',
          },
          gap: '{tw.gap._x-2}',
        },
        title: {
          color: '{text.muted.color}',
          active: {
            color: '{primary.color}',
          },
          font: {
            weight: '{tw.font-semibold}',
          },
        },
        number: {
          background: '{content.background}',
          active: {
            background: '{content.background}',
            border: {
              color: '{content.border.color}',
            },
            color: '{primary.color}',
          },
          border: {
            color: '{content.border.color}',
            radius: '{tw.rounded.xl}',
          },
          color: '{text.muted.color}',
          size: '2.286rem',
          font: {
            size: '{tw.text-xl}',
            weight: '{tw.font-semibold}',
          },
        },
        padding: '{tw.p.4}',
        gap: '{tw.gap._x-4}',
      },
      steppanel: {
        background: '{content.background}',
        color: '{content.color}',
        padding: '0rem',
        indent: '1.143rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    inplace: {
      focus: {
        ring: {
          color: '{focus.ring.color}',
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      display: {
        hover: {
          background: '{content.hover.background}',
          color: '{content.hover.color}',
        },
      },
      border: {
        radius: '{content.border.radius}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    metergroup: {
      meters: {
        background: '{content.border.color}',
        size: '0.571rem',
      },
      gap: '{tw.gap._x-4}',
      label: {
        gap: '0.571rem',
        marker: {
          size: '0.571rem',
        },
        icon: {
          size: '1.143rem',
        },
        list: {
          vertical: {
            gap: '{tw.gap._x-2}',
          },
          horizontal: {
            gap: '{tw.gap._x-4}',
          },
        },
      },
      border: {
        radius: '{content.border.radius}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    terminal: {
      background: '{form.field.background}',
      border: {
        color: '{form.field.border.color}',
        radius: '{form.field.border.radius}',
      },
      color: '{form.field.color}',
      height: '20.571rem',
      prompt: {
        gap: '{tw.gap._x-1_5}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    imagecompare: {
      handle: {
        background: '#ffffff4d',
        hover: {
          background: '#ffffff4d',
          border: {
            color: '#00000000',
          },
          size: '2.143rem',
        },
        border: {
          color: '#00000000',
          width: '0rem',
          radius: '0.536rem',
        },
        focus: {
          ring: {
            color: '#ffffff4d',
            width: '{focus.ring.width}',
            offset: '{focus.ring.offset}',
          },
        },
        size: '1.071rem',
      },
      figma: {
        handle: {
          hover: {
            border: {
              radius: '1.071rem',
            },
          },
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    overlaybadge: {
      outline: {
        color: '{content.background}',
        width: '0.143rem',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    iftalabel: {
      color: '{form.field.float.label.color}',
      focus: {
        color: '{form.field.float.label.focus.color}',
      },
      invalid: {
        color: '{form.field.float.label.invalid.color}',
      },
      position: {
        x: '{form.field.padding.x}',
      },
      top: '{form.field.padding.y}',
      font: {
        size: '0.857rem',
        weight: '28.571rem',
      },
      input: {
        padding: {
          top: '1.714rem',
          bottom: '{form.field.padding.y}',
        },
      },
      figma: {
        line: {
          height: '{iftalabel.font.size}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    button: {
      border: {
        radius: '{form.field.border.radius}',
      },
      rounded: {
        border: {
          radius: '2.286rem',
        },
      },
      gap: '{tw.gap._x-2}',
      padding: {
        x: '{form.field.padding.x}',
        y: '{form.field.padding.y}',
      },
      icon: {
        only: {
          width: '2.857rem',
        },
      },
      sm: {
        font: {
          size: '{tw.text-base}',
        },
        padding: {
          x: '{tw.p.2_5}',
          y: '{tw.p.1_5}',
        },
        icon: {
          only: {
            width: '2.286rem',
          },
        },
      },
      lg: {
        font: {
          size: '{tw.text-xl}',
        },
        padding: {
          x: '{tw.p.3_5}',
          y: '{tw.p.2_5}',
        },
        icon: {
          only: {
            width: '3.429rem',
          },
        },
      },
      label: {
        font: {
          weight: '{tw.font-semibold}',
        },
      },
      focus: {
        ring: {
          width: '{focus.ring.width}',
          offset: '{focus.ring.offset}',
        },
      },
      badge: {
        size: '1.143rem',
      },
      figma: {
        sm: {
          icon: {
            size: '{button.sm.font.size}',
          },
        },
        lg: {
          icon: {
            size: '{button.lg.font.size}',
          },
        },
      },
      colorScheme: {
        light: {
          primary: {
            background: '{primary.color}',
            hover: {
              background: '{primary.hover.color}',
              border: {
                color: '{primary.hover.color}',
              },
              color: '{primary.contrast.color}',
            },
            active: {
              background: '{primary.active.color}',
              border: {
                color: '{primary.active.color}',
              },
              color: '{primary.contrast.color}',
            },
            border: {
              color: '{primary.color}',
            },
            color: '{primary.contrast.color}',
            focus: {
              ring: {
                color: '{primary.color}',
              },
            },
          },
          secondary: {
            background: '{surface.100}',
            hover: {
              background: '{surface.200}',
              border: {
                color: '{surface.200}',
              },
              color: '{surface.700}',
            },
            active: {
              background: '{surface.300}',
              border: {
                color: '{surface.300}',
              },
              color: '{surface.800}',
            },
            border: {
              color: '{surface.100}',
            },
            color: '{surface.600}',
            focus: {
              ring: {
                color: '{surface.600}',
              },
            },
          },
          info: {
            background: '{sky.500}',
            hover: {
              background: '{sky.600}',
              border: {
                color: '{sky.600}',
              },
              color: '{surface.0}',
            },
            active: {
              background: '{sky.700}',
              border: {
                color: '{sky.700}',
              },
              color: '{surface.0}',
            },
            border: {
              color: '{sky.500}',
            },
            color: '{surface.0}',
            focus: {
              ring: {
                color: '{sky.500}',
              },
            },
          },
          success: {
            background: '{green.500}',
            hover: {
              background: '{green.600}',
              border: {
                color: '{green.600}',
              },
              color: '{surface.0}',
            },
            active: {
              background: '{green.700}',
              border: {
                color: '{green.700}',
              },
              color: '{surface.0}',
            },
            border: {
              color: '{green.500}',
            },
            color: '{surface.0}',
            focus: {
              ring: {
                color: '{green.500}',
              },
            },
          },
          warn: {
            background: '{orange.500}',
            hover: {
              background: '{orange.600}',
              border: {
                color: '{orange.600}',
              },
              color: '{surface.0}',
            },
            active: {
              background: '{orange.700}',
              border: {
                color: '{orange.700}',
              },
              color: '{surface.0}',
            },
            border: {
              color: '{orange.500}',
            },
            color: '{surface.0}',
            focus: {
              ring: {
                color: '{orange.500}',
              },
            },
          },
          help: {
            background: '{purple.500}',
            hover: {
              background: '{purple.600}',
              border: {
                color: '{purple.600}',
              },
              color: '{surface.0}',
            },
            active: {
              background: '{purple.700}',
              border: {
                color: '{purple.700}',
              },
              color: '{surface.0}',
            },
            border: {
              color: '{purple.500}',
            },
            color: '{surface.0}',
            focus: {
              ring: {
                color: '{purple.500}',
              },
            },
          },
          danger: {
            background: '{red.500}',
            hover: {
              background: '{red.600}',
              border: {
                color: '{red.600}',
              },
              color: '{surface.0}',
            },
            active: {
              background: '{red.700}',
              border: {
                color: '{red.700}',
              },
              color: '{surface.0}',
            },
            border: {
              color: '{red.500}',
            },
            color: '{surface.0}',
            focus: {
              ring: {
                color: '{red.500}',
              },
            },
          },
          contrast: {
            background: '{surface.950}',
            hover: {
              background: '{surface.900}',
              border: {
                color: '{surface.900}',
              },
              color: '{surface.0}',
            },
            active: {
              background: '{surface.800}',
              border: {
                color: '{surface.800}',
              },
              color: '{surface.0}',
            },
            border: {
              color: '{surface.950}',
            },
            color: '{surface.0}',
            focus: {
              ring: {
                color: '{surface.950}',
              },
            },
          },
          outlined: {
            primary: {
              hover: {
                background: '{primary.50}',
              },
              active: {
                background: '{primary.100}',
              },
              border: {
                color: '{primary.200}',
              },
              color: '{primary.color}',
            },
            secondary: {
              hover: {
                background: '{surface.50}',
              },
              active: {
                background: '{surface.100}',
              },
              border: {
                color: '{surface.200}',
              },
              color: '{surface.500}',
            },
            success: {
              hover: {
                background: '{green.50}',
              },
              active: {
                background: '{green.100}',
              },
              border: {
                color: '{green.200}',
              },
              color: '{green.500}',
            },
            info: {
              hover: {
                background: '{sky.50}',
              },
              active: {
                background: '{sky.100}',
              },
              border: {
                color: '{sky.200}',
              },
              color: '{sky.500}',
            },
            warn: {
              hover: {
                background: '{orange.50}',
              },
              active: {
                background: '{orange.100}',
              },
              border: {
                color: '{orange.200}',
              },
              color: '{orange.500}',
            },
            help: {
              hover: {
                background: '{purple.50}',
              },
              active: {
                background: '{purple.100}',
              },
              border: {
                color: '{purple.200}',
              },
              color: '{purple.500}',
            },
            danger: {
              hover: {
                background: '{red.50}',
              },
              active: {
                background: '{red.100}',
              },
              border: {
                color: '{red.200}',
              },
              color: '{red.500}',
            },
            contrast: {
              hover: {
                background: '{surface.50}',
              },
              active: {
                background: '{surface.100}',
              },
              border: {
                color: '{surface.700}',
              },
              color: '{surface.950}',
            },
            plain: {
              hover: {
                background: '{surface.50}',
              },
              active: {
                background: '{surface.100}',
              },
              border: {
                color: '{surface.200}',
              },
              color: '{surface.700}',
            },
          },
          text: {
            primary: {
              hover: {
                background: '{primary.50}',
              },
              active: {
                background: '{primary.100}',
              },
              color: '{primary.color}',
            },
            secondary: {
              hover: {
                background: '{surface.50}',
              },
              active: {
                background: '{surface.100}',
              },
              color: '{surface.500}',
            },
            success: {
              hover: {
                background: '{green.50}',
              },
              active: {
                background: '{green.100}',
              },
              color: '{green.500}',
            },
            info: {
              hover: {
                background: '{sky.50}',
              },
              active: {
                background: '{sky.100}',
              },
              color: '{sky.500}',
            },
            warn: {
              hover: {
                background: '{orange.50}',
              },
              active: {
                background: '{orange.100}',
              },
              color: '{orange.500}',
            },
            help: {
              hover: {
                background: '{purple.50}',
              },
              active: {
                background: '{purple.100}',
              },
              color: '{purple.500}',
            },
            danger: {
              hover: {
                background: '{red.50}',
              },
              active: {
                background: '{red.100}',
              },
              color: '{red.500}',
            },
            plain: {
              hover: {
                background: '{surface.50}',
              },
              active: {
                background: '{surface.100}',
              },
              color: '{surface.700}',
            },
            contrast: {
              hover: {
                background: '{surface.50}',
              },
              active: {
                background: '{surface.100}',
              },
              color: '{surface.950}',
            },
          },
          link: {
            color: '{primary.color}',
            hover: {
              color: '{primary.color}',
            },
            active: {
              color: '{primary.color}',
            },
          },
          figma: {
            raised: {
              background: '#ffffff03',
            },
          },
        },
        dark: {
          primary: {
            background: '{primary.color}',
            hover: {
              background: '{primary.hover.color}',
              border: {
                color: '{primary.hover.color}',
              },
              color: '{primary.contrast.color}',
            },
            active: {
              background: '{primary.active.color}',
              border: {
                color: '{primary.active.color}',
              },
              color: '{primary.contrast.color}',
            },
            border: {
              color: '{primary.color}',
            },
            color: '{primary.contrast.color}',
            focus: {
              ring: {
                color: '{primary.color}',
              },
            },
          },
          secondary: {
            background: '{surface.800}',
            hover: {
              background: '{surface.700}',
              border: {
                color: '{surface.700}',
              },
              color: '{surface.200}',
            },
            active: {
              background: '{surface.600}',
              border: {
                color: '{surface.600}',
              },
              color: '{surface.100}',
            },
            border: {
              color: '{surface.800}',
            },
            color: '{surface.300}',
            focus: {
              ring: {
                color: '{surface.300}',
              },
            },
          },
          info: {
            background: '{sky.400}',
            hover: {
              background: '{sky.300}',
              border: {
                color: '{sky.300}',
              },
              color: '{sky.950}',
            },
            active: {
              background: '{sky.200}',
              border: {
                color: '{sky.200}',
              },
              color: '{sky.950}',
            },
            border: {
              color: '{sky.400}',
            },
            color: '{sky.950}',
            focus: {
              ring: {
                color: '{sky.400}',
              },
            },
          },
          success: {
            background: '{green.400}',
            hover: {
              background: '{green.300}',
              border: {
                color: '{green.300}',
              },
              color: '{green.950}',
            },
            active: {
              background: '{green.200}',
              border: {
                color: '{green.200}',
              },
              color: '{green.950}',
            },
            border: {
              color: '{green.400}',
            },
            color: '{green.950}',
            focus: {
              ring: {
                color: '{green.400}',
              },
            },
          },
          warn: {
            background: '{orange.400}',
            hover: {
              background: '{orange.300}',
              border: {
                color: '{orange.300}',
              },
              color: '{orange.950}',
            },
            active: {
              background: '{orange.200}',
              border: {
                color: '{orange.200}',
              },
              color: '{orange.950}',
            },
            border: {
              color: '{orange.400}',
            },
            color: '{orange.950}',
            focus: {
              ring: {
                color: '{orange.400}',
              },
            },
          },
          help: {
            background: '{purple.400}',
            hover: {
              background: '{purple.300}',
              border: {
                color: '{purple.300}',
              },
              color: '{purple.950}',
            },
            active: {
              background: '{purple.200}',
              border: {
                color: '{purple.200}',
              },
              color: '{purple.950}',
            },
            border: {
              color: '{purple.400}',
            },
            color: '{purple.950}',
            focus: {
              ring: {
                color: '{purple.400}',
              },
            },
          },
          danger: {
            background: '{red.400}',
            hover: {
              background: '{red.300}',
              border: {
                color: '{red.300}',
              },
              color: '{red.950}',
            },
            active: {
              background: '{red.200}',
              border: {
                color: '{red.200}',
              },
              color: '{red.950}',
            },
            border: {
              color: '{red.400}',
            },
            color: '{red.950}',
            focus: {
              ring: {
                color: '{red.400}',
              },
            },
          },
          contrast: {
            background: '{surface.0}',
            hover: {
              background: '{surface.100}',
              border: {
                color: '{surface.100}',
              },
              color: '{surface.950}',
            },
            active: {
              background: '{surface.200}',
              border: {
                color: '{surface.200}',
              },
              color: '{surface.950}',
            },
            border: {
              color: '{surface.0}',
            },
            color: '{surface.950}',
            focus: {
              ring: {
                color: '{surface.0}',
              },
            },
          },
          outlined: {
            primary: {
              hover: {
                background: '#d435350a',
              },
              active: {
                background: '#d4353529',
              },
              border: {
                color: '{primary.700}',
              },
              color: '{primary.color}',
            },
            secondary: {
              hover: {
                background: '#ffffff0a',
              },
              active: {
                background: '#ffffff29',
              },
              border: {
                color: '{surface.700}',
              },
              color: '{surface.400}',
            },
            success: {
              hover: {
                background: '#4ade800a',
              },
              active: {
                background: '#4ade8029',
              },
              border: {
                color: '{green.700}',
              },
              color: '{green.400}',
            },
            info: {
              hover: {
                background: '#38bdf80a',
              },
              active: {
                background: '#38bdf829',
              },
              border: {
                color: '{sky.700}',
              },
              color: '{sky.400}',
            },
            warn: {
              hover: {
                background: '#fb923c0a',
              },
              active: {
                background: '#fb923c29',
              },
              border: {
                color: '{orange.700}',
              },
              color: '{sky.700}',
            },
            help: {
              hover: {
                background: '#c084fc0a',
              },
              active: {
                background: '#c084fc29',
              },
              border: {
                color: '{purple.700}',
              },
              color: '{purple.400}',
            },
            danger: {
              hover: {
                background: '#f871710a',
              },
              active: {
                background: '#f8717129',
              },
              border: {
                color: '{red.700}',
              },
              color: '{red.400}',
            },
            contrast: {
              hover: {
                background: '{surface.800}',
              },
              active: {
                background: '{surface.700}',
              },
              border: {
                color: '{surface.500}',
              },
              color: '{surface.0}',
            },
            plain: {
              hover: {
                background: '{surface.800}',
              },
              active: {
                background: '{surface.700}',
              },
              border: {
                color: '{surface.600}',
              },
              color: '{surface.0}',
            },
          },
          text: {
            primary: {
              hover: {
                background: '#d435350a',
              },
              active: {
                background: '#d4353529',
              },
              color: '{primary.color}',
            },
            secondary: {
              hover: {
                background: '{surface.800}',
              },
              active: {
                background: '{surface.700}',
              },
              color: '{surface.400}',
            },
            success: {
              hover: {
                background: '#4ade800a',
              },
              active: {
                background: '#4ade8029',
              },
              color: '{green.400}',
            },
            info: {
              hover: {
                background: '#38bdf80a',
              },
              active: {
                background: '#38bdf829',
              },
              color: '{sky.400}',
            },
            warn: {
              hover: {
                background: '#fb923c0a',
              },
              active: {
                background: '#fb923c29',
              },
              color: '{orange.400}',
            },
            help: {
              hover: {
                background: '#c084fc0a',
              },
              active: {
                background: '#c084fc29',
              },
              color: '{purple.400}',
            },
            danger: {
              hover: {
                background: '#f871710a',
              },
              active: {
                background: '#f8717129',
              },
              color: '{red.400}',
            },
            plain: {
              hover: {
                background: '{surface.800}',
              },
              active: {
                background: '{surface.700}',
              },
              color: '{surface.0}',
            },
            contrast: {
              hover: {
                background: '{surface.800}',
              },
              active: {
                background: '{surface.700}',
              },
              color: '{surface.0}',
            },
          },
          link: {
            color: '{primary.color}',
            hover: {
              color: '{primary.color}',
            },
            active: {
              color: '{primary.color}',
            },
          },
          figma: {
            raised: {
              background: '#00000003',
            },
          },
        },
      },
    },
    badge: {
      border: {
        radius: '{tw.rounded.md}',
      },
      font: {
        size: '{tw.text-sm}',
        weight: '{tw.font-bold}',
      },
      min: {
        width: '1.714rem',
      },
      height: '1.714rem',
      dot: {
        size: '0.571rem',
      },
      sm: {
        font: {
          size: '{tw.text-xs}',
        },
        min: {
          width: '1.429rem',
        },
        height: '1.429rem',
      },
      lg: {
        font: {
          size: '{tw.text-base}',
        },
        min: {
          width: '2rem',
        },
        height: '2rem',
      },
      xl: {
        font: {
          size: '{tw.text-lg}',
        },
        min: {
          width: '2.286rem',
        },
        height: '2.286rem',
      },
      colorScheme: {
        light: {
          primary: {
            background: '{primary.color}',
            color: '{primary.contrast.color}',
          },
          secondary: {
            background: '{surface.100}',
            color: '{surface.600}',
          },
          success: {
            background: '{green.500}',
            color: '{surface.0}',
          },
          info: {
            background: '{sky.500}',
            color: '{surface.0}',
          },
          warn: {
            background: '{orange.500}',
            color: '{surface.0}',
          },
          danger: {
            background: '{red.500}',
            color: '{surface.0}',
          },
          contrast: {
            background: '{surface.950}',
            color: '{surface.0}',
          },
        },
        dark: {
          primary: {
            background: '{primary.color}',
            color: '{primary.contrast.color}',
          },
          secondary: {
            background: '{surface.800}',
            color: '{surface.300}',
          },
          success: {
            background: '{green.400}',
            color: '{green.950}',
          },
          info: {
            background: '{sky.400}',
            color: '{sky.950}',
          },
          warn: {
            background: '{orange.400}',
            color: '{orange.950}',
          },
          danger: {
            background: '{red.400}',
            color: '{red.950}',
          },
          contrast: {
            background: '{surface.0}',
            color: '{surface.950}',
          },
        },
      },
    },
    message: {
      border: {
        radius: '{content.border.radius}',
        width: '{tw.border.1}',
      },
      content: {
        gap: '{tw.gap._x-2}',
      },
      text: {
        font: {
          size: '{tw.text-lg}',
          weight: '{tw.font-semibold}',
        },
        sm: {
          font: {
            size: '{tw.text-base}',
          },
        },
        lg: {
          font: {
            size: '{tw.text-xl}',
          },
        },
      },
      icon: {
        size: '1.286rem',
        sm: {
          size: '1.143rem',
        },
        lg: {
          size: '1.429rem',
        },
      },
      close: {
        button: {
          width: '2rem',
          height: '2rem',
          border: {
            radius: '1rem',
          },
          focus: {
            ring: {
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
        },
        icon: {
          size: '1.143rem',
          sm: {
            size: '1rem',
          },
          lg: {
            size: '1.286rem',
          },
        },
      },
      outlined: {
        border: {
          width: '{tw.border.1}',
        },
      },
      simple: {
        content: {
          padding: '0rem',
        },
      },
      colorScheme: {
        light: {
          info: {
            background: '#eff6fff2',
            border: {
              color: '{blue.200}',
            },
            color: '{blue.600}',
            close: {
              button: {
                hover: {
                  background: '{blue.100}',
                },
                focus: {
                  ring: {
                    color: '{blue.600}',
                  },
                },
              },
            },
            outlined: {
              color: '{blue.600}',
              border: {
                color: '{blue.600}',
              },
            },
            simple: {
              color: '{blue.600}',
            },
          },
          success: {
            background: '#f0fdf4f2',
            border: {
              color: '{green.200}',
            },
            color: '{green.600}',
            close: {
              button: {
                hover: {
                  background: '{green.100}',
                },
                focus: {
                  ring: {
                    color: '{green.600}',
                  },
                },
              },
            },
            outlined: {
              color: '{green.600}',
              border: {
                color: '{green.600}',
              },
            },
            simple: {
              color: '{green.600}',
            },
          },
          warn: {
            background: '#fefce8f2',
            border: {
              color: '{yellow.200}',
            },
            close: {
              button: {
                hover: {
                  background: '{yellow.100}',
                },
                focus: {
                  ring: {
                    color: '{yellow.600}',
                  },
                },
              },
            },
            color: '{yellow.600}',
            outlined: {
              color: '{yellow.600}',
              border: {
                color: '{yellow.600}',
              },
            },
            simple: {
              color: '{yellow.600}',
            },
          },
          error: {
            background: '#fef2f2f2',
            border: {
              color: '{red.200}',
            },
            color: '{red.600}',
            close: {
              button: {
                hover: {
                  background: '{red.100}',
                },
                focus: {
                  ring: {
                    color: '{red.600}',
                  },
                },
              },
            },
            outlined: {
              color: '{red.600}',
              border: {
                color: '{red.600}',
              },
            },
            simple: {
              color: '{red.600}',
            },
          },
          secondary: {
            background: '{surface.100}',
            border: {
              color: '{surface.200}',
            },
            color: '{surface.600}',
            close: {
              button: {
                hover: {
                  background: '{surface.200}',
                },
                focus: {
                  ring: {
                    color: '{surface.600}',
                  },
                },
              },
            },
            outlined: {
              color: '{surface.500}',
              border: {
                color: '{surface.500}',
              },
            },
            simple: {
              color: '{surface.500}',
            },
          },
          contrast: {
            background: '{surface.900}',
            border: {
              color: '{surface.950}',
            },
            color: '{surface.50}',
            close: {
              button: {
                hover: {
                  background: '{surface.800}',
                },
                focus: {
                  ring: {
                    color: '{surface.50}',
                  },
                },
              },
            },
            outlined: {
              color: '{surface.950}',
              border: {
                color: '{surface.950}',
              },
            },
            simple: {
              color: '{surface.950}',
            },
          },
        },
        dark: {
          info: {
            background: '#3b82f629',
            border: {
              color: '#1d4ed85c',
            },
            color: '{blue.500}',
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{blue.500}',
                  },
                },
              },
            },
            outlined: {
              color: '{blue.500}',
              border: {
                color: '{blue.500}',
              },
            },
            simple: {
              color: '{blue.500}',
            },
          },
          success: {
            background: '#22c55e29',
            border: {
              color: '#15803d5c',
            },
            color: '{green.500}',
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{green.500}',
                  },
                },
              },
            },
            outlined: {
              color: '{green.500}',
              border: {
                color: '{green.500}',
              },
            },
            simple: {
              color: '{green.500}',
            },
          },
          warn: {
            background: '#eab30829',
            border: {
              color: '#a162075c',
            },
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{yellow.500}',
                  },
                },
              },
            },
            color: '{yellow.500}',
            outlined: {
              color: '{yellow.500}',
              border: {
                color: '{yellow.500}',
              },
            },
            simple: {
              color: '{yellow.500}',
            },
          },
          error: {
            background: '#ef444429',
            border: {
              color: '#b91c1c5c',
            },
            color: '{red.500}',
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{red.500}',
                  },
                },
              },
            },
            outlined: {
              color: '{red.500}',
              border: {
                color: '{red.500}',
              },
            },
            simple: {
              color: '{red.500}',
            },
          },
          secondary: {
            background: '{surface.800}',
            border: {
              color: '{surface.700}',
            },
            color: '{surface.300}',
            close: {
              button: {
                hover: {
                  background: '{surface.700}',
                },
                focus: {
                  ring: {
                    color: '{surface.300}',
                  },
                },
              },
            },
            outlined: {
              color: '{surface.400}',
              border: {
                color: '{surface.400}',
              },
            },
            simple: {
              color: '{surface.400}',
            },
          },
          contrast: {
            background: '{surface.0}',
            border: {
              color: '{surface.100}',
            },
            color: '{surface.950}',
            close: {
              button: {
                hover: {
                  background: '{surface.100}',
                },
                focus: {
                  ring: {
                    color: '{surface.950}',
                  },
                },
              },
            },
            outlined: {
              color: '{surface.0}',
              border: {
                color: '{surface.0}',
              },
            },
            simple: {
              color: '{surface.0}',
            },
          },
        },
      },
    },
    tag: {
      font: {
        size: '{tw.text-base}',
        weight: '{tw.font-bold}',
      },
      gap: '{tw.gap._x-1_5}',
      border: {
        radius: '{content.border.radius}',
      },
      rounded: {
        border: {
          radius: '{tw.rounded.xl}',
        },
      },
      icon: {
        size: '0.857rem',
      },
      colorScheme: {
        light: {
          primary: {
            background: '{primary.100}',
            color: '{primary.700}',
          },
          secondary: {
            background: '{surface.100}',
            color: '{surface.600}',
          },
          success: {
            background: '{green.100}',
            color: '{green.700}',
          },
          info: {
            background: '{sky.100}',
            color: '{sky.700}',
          },
          warn: {
            background: '{orange.100}',
            color: '{coral.700}',
          },
          danger: {
            background: '{red.100}',
            color: '{red.700}',
          },
          contrast: {
            background: '{surface.950}',
            color: '{surface.0}',
          },
          figma: {
            container: {
              background: '#00000000',
            },
          },
        },
        dark: {
          primary: {
            background: '#ba111129',
            color: '{primary.300}',
          },
          secondary: {
            background: '{surface.800}',
            color: '{surface.300}',
          },
          success: {
            background: '#22c55e29',
            color: '{green.300}',
          },
          info: {
            background: '#0ea5e929',
            color: '{sky.300}',
          },
          warn: {
            background: '#f9731629',
            color: '{orange.300}',
          },
          danger: {
            background: '#ef444429',
            color: '{red.300}',
          },
          contrast: {
            background: '{surface.0}',
            color: '{surface.950}',
          },
          figma: {
            container: {
              background: '#000000b3',
            },
          },
        },
      },
    },
    skeleton: {
      border: {
        radius: '{content.border.radius}',
      },
      colorScheme: {
        light: {
          background: '{surface.200}',
          animation: {
            background: '#ffffff66',
          },
        },
        dark: {
          background: '#ffffff0f',
          animation: {
            background: '#ffffff0a',
          },
        },
      },
    },
    overlay: {
      title: {
        font: {
          size: '{tw.text-3xl}',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    inputnumber: {
      button: {
        width: '2.857rem',
        border: {
          radius: '{form.field.border.radius}',
        },
        vertical: {
          padding: '{form.field.padding.y}',
        },
      },
      colorScheme: {
        light: {
          button: {
            background: '#00000000',
            hover: {
              background: '{surface.100}',
              border: {
                color: '{form.field.border.color}',
              },
              color: '{surface.500}',
            },
            active: {
              background: '{surface.200}',
              border: {
                color: '{form.field.border.color}',
              },
              color: '{surface.600}',
            },
            border: {
              color: '{form.field.border.color}',
            },
            color: '{surface.400}',
          },
        },
        dark: {
          button: {
            background: '#00000000',
            hover: {
              background: '{surface.800}',
              border: {
                color: '{form.field.border.color}',
              },
              color: '{surface.300}',
            },
            active: {
              background: '{surface.700}',
              border: {
                color: '{form.field.border.color}',
              },
              color: '{surface.200}',
            },
            border: {
              color: '{form.field.border.color}',
            },
            color: '{surface.400}',
          },
        },
      },
    },
    selectbutton: {
      border: {
        radius: '{form.field.border.radius}',
      },
      colorScheme: {
        light: {
          invalid: {
            border: {
              color: '{form.field.invalid.border.color}',
            },
          },
        },
        dark: {
          invalid: {
            border: {
              color: '{form.field.invalid.border.color}',
            },
          },
        },
      },
    },
    tooltip: {
      max: {
        width: '14.286rem',
      },
      gutter: '0.286rem',
      border: {
        radius: '{overlay.popover.border.radius}',
      },
      colorScheme: {
        light: {
          background: '{surface.700}',
          color: '{surface.0}',
        },
        dark: {
          background: '{surface.700}',
          color: '{surface.0}',
        },
      },
    },
    orderlist: {
      gap: '1.286rem',
      controls: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    picklist: {
      gap: '1.286rem',
      controls: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    toast: {
      width: '28.571rem',
      border: {
        radius: '{content.border.radius}',
        width: '{tw.border.1}',
      },
      icon: {
        size: '1.286rem',
      },
      content: {
        padding: '{overlay.popover.padding}',
        gap: '{tw.gap._x-2}',
      },
      summary: {
        font: {
          weight: '{tw.font-semibold}',
          size: '{tw.text-lg}',
        },
      },
      detail: {
        font: {
          weight: '{tw.font-semibold}',
          size: '{tw.text-base}',
        },
      },
      close: {
        button: {
          width: '2rem',
          height: '2rem',
          border: {
            radius: '1rem',
          },
          focus: {
            ring: {
              width: '{focus.ring.width}',
              offset: '{focus.ring.offset}',
            },
          },
        },
        icon: {
          size: '1.143rem',
        },
      },
      text: {
        gap: '{tw.gap._x-2}',
      },
      colorScheme: {
        light: {
          info: {
            background: '#eff6fff2',
            border: {
              color: '{blue.200}',
            },
            color: '{blue.600}',
            detail: {
              color: '{surface.700}',
            },
            close: {
              button: {
                hover: {
                  background: '{blue.100}',
                },
                focus: {
                  ring: {
                    color: '{blue.600}',
                  },
                },
              },
            },
          },
          success: {
            background: '#f0fdf4f2',
            border: {
              color: '{green.200}',
            },
            color: '{green.600}',
            detail: {
              color: '{surface.700}',
            },
            close: {
              button: {
                hover: {
                  background: '{green.100}',
                },
                focus: {
                  ring: {
                    color: '{green.600}',
                  },
                },
              },
            },
          },
          warn: {
            background: '#fefce8f2',
            border: {
              color: '{yellow.200}',
            },
            color: '{yellow.600}',
            detail: {
              color: '{surface.700}',
            },
            close: {
              button: {
                hover: {
                  background: '{yellow.100}',
                },
                focus: {
                  ring: {
                    color: '{yellow.600}',
                  },
                },
              },
            },
          },
          error: {
            background: '#fef2f2f2',
            border: {
              color: '{red.200}',
            },
            color: '{red.600}',
            detail: {
              color: '{surface.700}',
            },
            close: {
              button: {
                hover: {
                  background: '{red.100}',
                },
                focus: {
                  ring: {
                    color: '{red.600}',
                  },
                },
              },
            },
          },
          secondary: {
            background: '{surface.100}',
            border: {
              color: '{surface.200}',
            },
            color: '{surface.600}',
            detail: {
              color: '{surface.700}',
            },
            close: {
              button: {
                hover: {
                  background: '{surface.200}',
                },
                focus: {
                  ring: {
                    color: '{surface.600}',
                  },
                },
              },
            },
          },
          contrast: {
            background: '{surface.900}',
            border: {
              color: '{surface.950}',
            },
            color: '{surface.50}',
            detail: {
              color: '{surface.0}',
            },
            close: {
              button: {
                hover: {
                  background: '{surface.800}',
                },
                focus: {
                  ring: {
                    color: '{surface.50}',
                  },
                },
              },
            },
          },
          blur: '0.107rem',
        },
        dark: {
          info: {
            background: '#3b82f629',
            border: {
              color: '#1d4ed85c',
            },
            color: '{blue.500}',
            detail: {
              color: '{surface.0}',
            },
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{blue.500}',
                  },
                },
              },
            },
          },
          success: {
            background: '#22c55e29',
            border: {
              color: '#15803d5c',
            },
            color: '{green.500}',
            detail: {
              color: '{surface.0}',
            },
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{green.500}',
                  },
                },
              },
            },
          },
          warn: {
            background: '#eab30829',
            border: {
              color: '#a162075c',
            },
            color: '{yellow.500}',
            detail: {
              color: '{surface.0}',
            },
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{yellow.500}',
                  },
                },
              },
            },
          },
          error: {
            background: '#ef444429',
            border: {
              color: '#b91c1c5c',
            },
            color: '{tw.red.500}',
            detail: {
              color: '{surface.0}',
            },
            close: {
              button: {
                hover: {
                  background: '#ffffff0d',
                },
                focus: {
                  ring: {
                    color: '{tw.red.500}',
                  },
                },
              },
            },
          },
          secondary: {
            background: '{surface.800}',
            border: {
              color: '{surface.700}',
            },
            color: '{surface.300}',
            detail: {
              color: '{surface.0}',
            },
            close: {
              button: {
                hover: {
                  background: '{surface.700}',
                },
                focus: {
                  ring: {
                    color: '{surface.500}',
                  },
                },
              },
            },
          },
          contrast: {
            background: '{surface.0}',
            border: {
              color: '{surface.100}',
            },
            color: '{surface.950}',
            detail: {
              color: '{surface.950}',
            },
            close: {
              button: {
                hover: {
                  background: '{surface.100}',
                },
                focus: {
                  ring: {
                    color: '{surface.950}',
                  },
                },
              },
            },
          },
          blur: '0.714rem',
        },
      },
    },
    speeddial: {
      gap: '{tw.gap._x-2}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    splitbutton: {
      border: {
        radius: '{form.field.border.radius}',
      },
      rounded: {
        border: {
          radius: '2.286rem',
        },
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    blockui: {
      border: {
        radius: '{content.border.radius}',
      },
      colorScheme: {
        light: {},
        dark: {},
      },
    },
    inputotp: {
      input: {
        width: '2.857rem',
        sm: {
          width: '2.286rem',
        },
        lg: {
          width: '3.429rem',
        },
      },
      gap: '{tw.gap._x-2}',
      colorScheme: {
        light: {},
        dark: {},
      },
    },
  },
  extend: {
    tw: {
      emerald: {
        '50': '#ecfdf5',
        '100': '#d1fae5',
        '200': '#a7f3d0',
        '300': '#6ee7b7',
        '400': '#34d399',
        '500': '#10b981',
        '600': '#059669',
        '700': '#047857',
        '800': '#065f46',
        '900': '#064e3b',
        '950': '#022c22',
      },
      teal: {
        '50': '#f0fdfa',
        '100': '#ccfbf1',
        '200': '#99f6e4',
        '300': '#5eead4',
        '400': '#2dd4bf',
        '500': '#14b8a6',
        '600': '#0d9488',
        '700': '#0f766e',
        '800': '#115e59',
        '900': '#134e4a',
        '950': '#042f2e',
      },
      yellow: {
        '50': '#fefce8',
        '100': '#fef9c3',
        '200': '#fef08a',
        '300': '#fde047',
        '400': '#facc15',
        '500': '#eab308',
        '600': '#ca8a04',
        '700': '#a16207',
        '800': '#854d0e',
        '900': '#713f12',
        '950': '#422006',
      },
      amber: {
        '50': '#fffbeb',
        '100': '#fef3c7',
        '200': '#fde68a',
        '300': '#fcd34d',
        '400': '#fbbf24',
        '500': '#f59e0b',
        '600': '#d97706',
        '700': '#b45309',
        '800': '#92400e',
        '900': '#78350f',
        '950': '#451a03',
      },
      orange: {
        '50': '#fff7ed',
        '100': '#ffedd5',
        '200': '#fed7aa',
        '300': '#fdba74',
        '400': '#fb923c',
        '500': '#f97316',
        '600': '#ea580c',
        '700': '#c2410c',
        '800': '#9a3412',
        '900': '#7c2d12',
        '950': '#431407',
      },
      cyan: {
        '50': '#ecfeff',
        '100': '#cffafe',
        '200': '#a5f3fc',
        '300': '#67e8f9',
        '400': '#22d3ee',
        '500': '#06b6d4',
        '600': '#0891b2',
        '700': '#0e7490',
        '800': '#155e75',
        '900': '#164e63',
        '950': '#083344',
      },
      red: {
        '50': '#fef2f2',
        '100': '#fee2e2',
        '200': '#fecaca',
        '300': '#fca5a5',
        '400': '#f87171',
        '500': '#ef4444',
        '600': '#dc2626',
        '700': '#b91c1c',
        '800': '#991b1b',
        '900': '#7f1d1d',
        '950': '#450a0a',
      },
      lime: {
        '50': '#f7fee7',
        '100': '#ecfccb',
        '200': '#d9f99d',
        '300': '#bef264',
        '400': '#a3e635',
        '500': '#84cc16',
        '600': '#65a30d',
        '700': '#4d7c0f',
        '800': '#3f6212',
        '900': '#365314',
        '950': '#1a2e05',
      },
      indigo: {
        '50': '#eef2ff',
        '100': '#e0e7ff',
        '200': '#c7d2fe',
        '300': '#a5b4fc',
        '400': '#818cf8',
        '500': '#6366f1',
        '600': '#4f46e5',
        '700': '#4338ca',
        '800': '#3730a3',
        '900': '#312e81',
        '950': '#1e1b4b',
      },
      gray: {
        '50': '#f9fafb',
        '100': '#f3f4f6',
        '200': '#e5e7eb',
        '300': '#d1d5db',
        '400': '#9ca3af',
        '500': '#6b7280',
        '600': '#4b5563',
        '700': '#374151',
        '800': '#1f2937',
        '900': '#111827',
        '950': '#030712',
      },
      sky: {
        '50': '#f0f9ff',
        '100': '#e0f2fe',
        '200': '#bae6fd',
        '300': '#7dd3fc',
        '400': '#38bdf8',
        '500': '#0ea5e9',
        '600': '#0284c7',
        '700': '#0369a1',
        '800': '#075985',
        '900': '#0c4a6e',
        '950': '#082f49',
      },
      green: {
        '50': '#f0fdf4',
        '100': '#dcfce7',
        '200': '#bbf7d0',
        '300': '#86efac',
        '400': '#4ade80',
        '500': '#22c55e',
        '600': '#16a34a',
        '700': '#15803d',
        '800': '#166534',
        '900': '#14532d',
        '950': '#052e16',
      },
      stone: {
        '50': '#fafaf9',
        '100': '#f5f5f4',
        '200': '#e7e5e4',
        '300': '#d6d3d1',
        '400': '#a8a29e',
        '500': '#78716c',
        '600': '#57534e',
        '700': '#44403c',
        '800': '#292524',
        '900': '#1c1917',
        '950': '#0c0a09',
      },
      pink: {
        '50': '#fdf2f8',
        '100': '#fce7f3',
        '200': '#fbcfe8',
        '300': '#f9a8d4',
        '400': '#f472b6',
        '500': '#ec4899',
        '600': '#db2777',
        '700': '#be185d',
        '800': '#9d174d',
        '900': '#831843',
        '950': '#500724',
      },
      fuchsia: {
        '50': '#fdf4ff',
        '100': '#fae8ff',
        '200': '#f5d0fe',
        '300': '#f0abfc',
        '400': '#e879f9',
        '500': '#d946ef',
        '600': '#c026d3',
        '700': '#a21caf',
        '800': '#86198f',
        '900': '#701a75',
        '950': '#4a044e',
      },
      rose: {
        '50': '#fff1f2',
        '100': '#ffe4e6',
        '200': '#fecdd3',
        '300': '#fda4af',
        '400': '#fb7185',
        '500': '#f43f5e',
        '600': '#e11d48',
        '700': '#be123c',
        '800': '#9f1239',
        '900': '#881337',
        '950': '#4c0519',
      },
      neutral: {
        '50': '#fafafa',
        '100': '#f5f5f5',
        '200': '#e5e5e5',
        '300': '#d4d4d4',
        '400': '#a3a3a3',
        '500': '#737373',
        '600': '#525252',
        '700': '#404040',
        '800': '#262626',
        '900': '#171717',
        '950': '#0a0a0a',
      },
      zinc: {
        '50': '#fafafa',
        '100': '#f4f4f5',
        '200': '#e4e4e7',
        '300': '#d4d4d8',
        '400': '#a1a1aa',
        '500': '#71717a',
        '600': '#52525b',
        '700': '#3f3f46',
        '800': '#27272a',
        '900': '#18181b',
        '950': '#09090b',
      },
      blue: {
        '50': '#eff6ff',
        '100': '#dbeafe',
        '200': '#bfdbfe',
        '300': '#93c5fd',
        '400': '#60a5fa',
        '500': '#3b82f6',
        '600': '#2563eb',
        '700': '#1d4ed8',
        '800': '#1e40af',
        '900': '#1e3a8a',
        '950': '#172554',
      },
      slate: {
        '50': '#f8fafc',
        '100': '#f1f5f9',
        '200': '#e2e8f0',
        '300': '#cbd5e1',
        '400': '#94a3b8',
        '500': '#64748b',
        '600': '#475569',
        '700': '#334155',
        '800': '#1e293b',
        '900': '#0f172a',
        '950': '#020617',
      },
      violet: {
        '50': '#f5f3ff',
        '100': '#ede9fe',
        '200': '#ddd6fe',
        '300': '#c4b5fd',
        '400': '#a78bfa',
        '500': '#8b5cf6',
        '600': '#7c3aed',
        '700': '#6d28d9',
        '800': '#5b21b6',
        '900': '#4c1d95',
        '950': '#2e1065',
      },
      purple: {
        '50': '#faf5ff',
        '100': '#f3e8ff',
        '200': '#e9d5ff',
        '300': '#d8b4fe',
        '400': '#c084fc',
        '500': '#a855f7',
        '600': '#9333ea',
        '700': '#7e22ce',
        '800': '#6b21a8',
        '900': '#581c87',
        '950': '#3b0764',
      },
      caco: {
        '50': '#ffeedb',
        '100': '#fedeb8',
        '200': '#fbce95',
        '300': '#f5be72',
        '400': '#eeae4e',
        '500': '#d49b47',
        '600': '#ba8840',
        '700': '#a17638',
        '800': '#886531',
        '900': '#71542a',
        '950': '#5a4324',
      },
      litchi: {
        '50': '#fbfafa',
        '100': '#f6f5f4',
        '200': '#f2f1ef',
        '300': '#edece9',
        '400': '#e9e7e4',
        '500': '#cfcdcb',
        '600': '#b6b4b2',
        '700': '#9d9b9a',
        '800': '#858482',
        '900': '#6d6c6b',
        '950': '#575655',
      },
      cement: {
        '50': '#f6f7f6',
        '100': '#edefed',
        '200': '#e4e7e4',
        '300': '#dce0db',
        '400': '#d3d8d2',
        '500': '#bcc0bb',
        '600': '#a5a9a4',
        '700': '#8e928e',
        '800': '#797b78',
        '900': '#646663',
        '950': '#50514f',
      },
      kiwi: {
        '50': '#f8fadf',
        '100': '#f0f4be',
        '200': '#e6ef9e',
        '300': '#dcea7c',
        '400': '#d0e558',
        '500': '#b9cb50',
        '600': '#a3b248',
        '700': '#8d9a3f',
        '800': '#788337',
        '900': '#636c2f',
        '950': '#4f5628',
      },
      ocean: {
        '50': '#dae3e8',
        '100': '#b6c7d2',
        '200': '#93acbc',
        '300': '#6f92a7',
        '400': '#4a7992',
        '500': '#436c82',
        '600': '#3d6073',
        '700': '#365464',
        '800': '#2f4855',
        '900': '#293c47',
        '950': '#22313a',
      },
      plum: {
        '50': '#d9cddd',
        '100': '#b39cbb',
        '200': '#8f6e9b',
        '300': '#6a427b',
        '400': '#46155c',
        '500': '#401553',
        '600': '#39144a',
        '700': '#331341',
        '800': '#2d1238',
        '900': '#261130',
        '950': '#200f27',
      },
      curry: {
        '50': '#f1ead6',
        '100': '#e1d6ad',
        '200': '#d1c386',
        '300': '#bfb05e',
        '400': '#ac9d34',
        '500': '#998c30',
        '600': '#877b2c',
        '700': '#766b28',
        '800': '#645b24',
        '900': '#544c1f',
        '950': '#433d1b',
      },
      cacao: {
        '50': '#eddad3',
        '100': '#d9b6a9',
        '200': '#c49480',
        '300': '#ad725a',
        '400': '#955135',
        '500': '#854930',
        '600': '#76412c',
        '700': '#673a27',
        '800': '#583222',
        '900': '#4a2b1e',
        '950': '#3c241a',
      },
      wine: {
        '50': '#e7d5d8',
        '100': '#ceadb3',
        '200': '#b5868f',
        '300': '#9c606c',
        '400': '#813a4c',
        '500': '#743545',
        '600': '#66303d',
        '700': '#5a2b36',
        '800': '#4d262f',
        '900': '#412128',
        '950': '#351c21',
      },
      sea: {
        '50': '#e3eee8',
        '100': '#c8ded1',
        '200': '#adcebb',
        '300': '#92bda5',
        '400': '#77ad90',
        '500': '#6b9a81',
        '600': '#5f8871',
        '700': '#537663',
        '800': '#476454',
        '900': '#3c5346',
        '950': '#314339',
      },
      coal: {
        '50': '#d1d1d2',
        '100': '#a5a5a8',
        '200': '#7a7a7f',
        '300': '#535358',
        '400': '#2e2e34',
        '500': '#2a2a2f',
        '600': '#26262b',
        '700': '#222226',
        '800': '#1e1e22',
        '900': '#1a1a1d',
        '950': '#171719',
      },
      xfarm: {
        '50': '#dee8de',
        '100': '#bed1be',
        '200': '#9eba9f',
        '300': '#7fa480',
        '400': '#608e63',
        '500': '#567f59',
        '600': '#4d704f',
        '700': '#446145',
        '800': '#3b533c',
        '900': '#324633',
        '950': '#29382a',
      },
      cherry: {
        '50': '#f9d7d9',
        '100': '#efafb4',
        '200': '#e38891',
        '300': '#d45e6f',
        '400': '#c22c4f',
        '500': '#ad2a47',
        '600': '#99283f',
        '700': '#852538',
        '800': '#712231',
        '900': '#5e1f29',
        '950': '#4c1b22',
      },
      coral: {
        '50': '#fee2de',
        '100': '#fac6be',
        '200': '#f4aa9f',
        '300': '#ec8d80',
        '400': '#e27063',
        '500': '#c96559',
        '600': '#b1594f',
        '700': '#994e45',
        '800': '#82443c',
        '900': '#6c3933',
        '950': '#562f2a',
      },
      coffee: {
        '50': '#d6d1ce',
        '100': '#aea69f',
        '200': '#877c73',
        '300': '#625449',
        '400': '#3f3023',
        '500': '#392c20',
        '600': '#33281d',
        '700': '#2e231b',
        '800': '#281f18',
        '900': '#231b15',
        '950': '#1d1712',
      },
      grass: {
        '50': '#ddefe1',
        '100': '#bcdfc3',
        '200': '#9acea5',
        '300': '#78be89',
        '400': '#52ad6d',
        '500': '#4a9a62',
        '600': '#438857',
        '700': '#3c764c',
        '800': '#346441',
        '900': '#2d5337',
        '950': '#26432d',
      },
      'font-sans': 'Inter',
      italic: 'italic',
      'not-italic': 'normal',
      rounded: {
        xs: '0.143rem',
        '3xl': '1.714rem',
        '2xl': '1.143rem',
        xl: '0.857rem',
        md: '0.429rem',
        lg: '0.571rem',
        sm: '0.286rem',
      },
      'text-xs': '0.75rem',
      'text-sm': '0.875rem',
      'text-base': '1rem',
      'text-lg': '1.125rem',
      'text-4xl': '2.25rem',
      'text-3xl': '1.875rem',
      'text-2xl': '1.5rem',
      'text-xl': '1.25rem',
      'text-7xl': '4.5rem',
      'text-6xl': '3.75rem',
      'text-8xl': '6rem',
      'text-5xl': '3rem',
      'font-normal': 400,
      'font-semibold': 600,
      'font-bold': 700,
      'font-light': 300,
      gap: {
        '_x-1': '0.25rem',
        '_x-2': '0.5rem',
        '_x-4': '1rem',
        '_x-1_5': '0.375rem',
        '_x-3_5': '0.875rem',
        '_x-6': '1.5rem',
        '_x-10': '2.214rem',
      },
      p: {
        '1': '0.25rem',
        '2': '0.5rem',
        '3': '0.75rem',
        '4': '1rem',
        '5': '1.25rem',
        '6': '1.5rem',
        '10': '2.5rem',
        '4_5': '1.125rem',
        '3_5': '0.875rem',
        '2_5': '0.625rem',
        '1_5': '0.375rem',
      },
      border: {
        '1': '0.071rem',
        '2': '0.143rem',
      },
      spacing: '0.25rem',
    },
  },
};
